/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicRouteImport } from './routes/public/route'
import { Route as HrRouteImport } from './routes/hr/route'
import { Route as DocsRouteImport } from './routes/docs/route'
import { Route as CoRouteImport } from './routes/co/route'
import { Route as CmRouteImport } from './routes/cm/route'
import { Route as AppRouteImport } from './routes/app/route'
import { Route as IndexImport } from './routes/index'
import { Route as HrIndexImport } from './routes/hr/index'
import { Route as CoIndexImport } from './routes/co/index'
import { Route as CmIndexImport } from './routes/cm/index'
import { Route as AppIndexImport } from './routes/app/index'
import { Route as PublicSessionFeedbackImport } from './routes/public/session-feedback'
import { Route as PublicLeaderContextDocumentImport } from './routes/public/leader-context-document'
import { Route as DocsSessionFeedbackImport } from './routes/docs/session-feedback'
import { Route as CoInsightsImport } from './routes/co/insights'
import { Route as CmSplatImport } from './routes/cm/$'
import { Route as AuthSetupInitialPasswordImport } from './routes/auth/setup-initial-password'
import { Route as AuthSendPasswordResetEmailImport } from './routes/auth/send-password-reset-email'
import { Route as AuthResetPasswordFromLinkImport } from './routes/auth/reset-password-from-link'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as AuthPageSelectorImport } from './routes/auth/page-selector'
import { Route as AuthLogoutImport } from './routes/auth/logout'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthAccountLockedImport } from './routes/auth/account-locked'
import { Route as AppTermsAgreementImport } from './routes/app/terms-agreement'
import { Route as CoReservationRouteImport } from './routes/co/reservation/route'
import { Route as CmInternalRouteImport } from './routes/cm/internal/route'
import { Route as AppReservationRouteImport } from './routes/app/reservation/route'
import { Route as AppCycleRouteImport } from './routes/app/cycle/route'
import { Route as AppCoachRouteImport } from './routes/app/coach/route'
import { Route as HrCycleListIndexImport } from './routes/hr/cycle-list/index'
import { Route as HrCaseRegistrationIndexImport } from './routes/hr/case-registration/index'
import { Route as CoReservationIndexImport } from './routes/co/reservation/index'
import { Route as CoCycleListIndexImport } from './routes/co/cycle-list/index'
import { Route as CmSendReportsIndexImport } from './routes/cm/send-reports/index'
import { Route as CmCycleListIndexImport } from './routes/cm/cycle-list/index'
import { Route as CmCoachMatchingIndexImport } from './routes/cm/coach-matching/index'
import { Route as CmCaseListIndexImport } from './routes/cm/case-list/index'
import { Route as AuthAdminAccessIndexImport } from './routes/auth/admin-access/index'
import { Route as AppReservationIndexImport } from './routes/app/reservation/index'
import { Route as AppCycleIndexImport } from './routes/app/cycle/index'
import { Route as AppCoachIndexImport } from './routes/app/coach/index'
import { Route as PublicCoachingReportsCoachingReportIdImport } from './routes/public/coaching-reports/$coachingReportId'
import { Route as PublicCoachingPlansCoachingPlanIdImport } from './routes/public/coaching-plans/$coachingPlanId'
import { Route as PublicCoachingNotesCoachingNoteIdImport } from './routes/public/coaching-notes/$coachingNoteId'
import { Route as HrCycleListCompanyIdImport } from './routes/hr/cycle-list/$companyId'
import { Route as DocsPeerFeedbackReportsPeerFeedbackReportIdImport } from './routes/docs/peer-feedback-reports/$peerFeedbackReportId'
import { Route as DocsOnboardingSurveyIdImport } from './routes/docs/onboarding-survey/$id'
import { Route as DocsOccupationalHealthReportIdImport } from './routes/docs/occupational-health-report/$id'
import { Route as DocsMissionSummaryIdImport } from './routes/docs/mission-summary/$id'
import { Route as DocsLeadershipSummaryIdImport } from './routes/docs/leadership-summary/$id'
import { Route as DocsCoachingReportsCoachingReportIdImport } from './routes/docs/coaching-reports/$coachingReportId'
import { Route as DocsCoachingPlansCoachingPlanIdImport } from './routes/docs/coaching-plans/$coachingPlanId'
import { Route as DocsCoachingNotesCoachingNoteIdImport } from './routes/docs/coaching-notes/$coachingNoteId'
import { Route as CoCycleListCompanyIdImport } from './routes/co/cycle-list/$companyId'
import { Route as CoCycleDetailCycleIdImport } from './routes/co/cycle-detail/$cycleId'
import { Route as CoCaseDetailCaseIdImport } from './routes/co/case-detail/$caseId'
import { Route as CmSendReportsCompanyIdImport } from './routes/cm/send-reports/$companyId'
import { Route as CmInternalCompanyStatusImport } from './routes/cm/internal/company-status'
import { Route as CmInternalAdminAccessImport } from './routes/cm/internal/admin-access'
import { Route as CmCycleListCompanyIdImport } from './routes/cm/cycle-list/$companyId'
import { Route as CmCycleDetailCycleIdImport } from './routes/cm/cycle-detail/$cycleId'
import { Route as CmCoachMatchingCompanyIdImport } from './routes/cm/coach-matching/$companyId'
import { Route as CmCaseListCompanyIdImport } from './routes/cm/case-list/$companyId'
import { Route as CmCaseDetailCaseIdImport } from './routes/cm/case-detail/$caseId'
import { Route as AuthHrSetupInitialPasswordImport } from './routes/auth/hr/setup-initial-password'
import { Route as AuthAdminAccessEndedImport } from './routes/auth/admin-access/ended'
import { Route as AppReservationFirstImport } from './routes/app/reservation/first'
import { Route as AppReservationDetailsImport } from './routes/app/reservation/details'
import { Route as AppCoachProfileImport } from './routes/app/coach/profile'
import { Route as CmInternalNotificationTemplatesRouteImport } from './routes/cm/internal/notification-templates/route'
import { Route as CmInternalNotificationTemplatesIndexImport } from './routes/cm/internal/notification-templates/index'
import { Route as CmInternalInsightsIndexImport } from './routes/cm/internal/insights/index'
import { Route as CmInternalEmailIndexImport } from './routes/cm/internal/email/index'
import { Route as CmInternalConsoleDataIndexImport } from './routes/cm/internal/console-data/index'
import { Route as CmInternalCoachListIndexImport } from './routes/cm/internal/coach-list/index'
import { Route as CmInternalAlignmentCallsIndexImport } from './routes/cm/internal/alignment-calls/index'
import { Route as CmInternalNotificationTemplatesCompanyIdImport } from './routes/cm/internal/notification-templates/$companyId'
import { Route as CmInternalConsoleDataCompanyIdImport } from './routes/cm/internal/console-data/$companyId'
import { Route as CmInternalAlignmentCallsCompanyIdImport } from './routes/cm/internal/alignment-calls/$companyId'
import { Route as AppCycleCycleIdSurveyIndexImport } from './routes/app/cycle/$cycleId/survey/index'
import { Route as CmInternalInsightsCompaniesCompanyIdImport } from './routes/cm/internal/insights/companies.$companyId'
import { Route as CmInternalInsightsCoachesCoachIdImport } from './routes/cm/internal/insights/coaches.$coachId'
import { Route as AppCycleCycleIdSurveyOnboardingIndexImport } from './routes/app/cycle/$cycleId/survey/onboarding/index'
import { Route as AppCycleCycleIdSurveyFortySurveyTypeIndexImport } from './routes/app/cycle/$cycleId/survey/$fortySurveyType/index'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/route'
import { Route as AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteImport } from './routes/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/route'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdIndexImport } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/index'
import { Route as AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexImport } from './routes/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/index'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultImport } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Import } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Import } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroImport } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingImport } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroImport } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPages3Import } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPages2Import } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2'
import { Route as AppCycleCycleIdSurveyOnboardingSurveyIdPages1Import } from './routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1'
import { Route as AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageImport } from './routes/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page'

// Create/Update Routes

const PublicRouteRoute = PublicRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => rootRoute,
} as any)

const HrRouteRoute = HrRouteImport.update({
  id: '/hr',
  path: '/hr',
  getParentRoute: () => rootRoute,
} as any)

const DocsRouteRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRoute,
} as any)

const CoRouteRoute = CoRouteImport.update({
  id: '/co',
  path: '/co',
  getParentRoute: () => rootRoute,
} as any)

const CmRouteRoute = CmRouteImport.update({
  id: '/cm',
  path: '/cm',
  getParentRoute: () => rootRoute,
} as any)

const AppRouteRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const HrIndexRoute = HrIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HrRouteRoute,
} as any)

const CoIndexRoute = CoIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CoRouteRoute,
} as any)

const CmIndexRoute = CmIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CmRouteRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)

const PublicSessionFeedbackRoute = PublicSessionFeedbackImport.update({
  id: '/session-feedback',
  path: '/session-feedback',
  getParentRoute: () => PublicRouteRoute,
} as any)

const PublicLeaderContextDocumentRoute =
  PublicLeaderContextDocumentImport.update({
    id: '/leader-context-document',
    path: '/leader-context-document',
    getParentRoute: () => PublicRouteRoute,
  } as any)

const DocsSessionFeedbackRoute = DocsSessionFeedbackImport.update({
  id: '/session-feedback',
  path: '/session-feedback',
  getParentRoute: () => DocsRouteRoute,
} as any)

const CoInsightsRoute = CoInsightsImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => CoRouteRoute,
} as any)

const CmSplatRoute = CmSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => CmRouteRoute,
} as any)

const AuthSetupInitialPasswordRoute = AuthSetupInitialPasswordImport.update({
  id: '/auth/setup-initial-password',
  path: '/auth/setup-initial-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthSendPasswordResetEmailRoute = AuthSendPasswordResetEmailImport.update(
  {
    id: '/auth/send-password-reset-email',
    path: '/auth/send-password-reset-email',
    getParentRoute: () => rootRoute,
  } as any,
)

const AuthResetPasswordFromLinkRoute = AuthResetPasswordFromLinkImport.update({
  id: '/auth/reset-password-from-link',
  path: '/auth/reset-password-from-link',
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthPageSelectorRoute = AuthPageSelectorImport.update({
  id: '/auth/page-selector',
  path: '/auth/page-selector',
  getParentRoute: () => rootRoute,
} as any)

const AuthLogoutRoute = AuthLogoutImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthAccountLockedRoute = AuthAccountLockedImport.update({
  id: '/auth/account-locked',
  path: '/auth/account-locked',
  getParentRoute: () => rootRoute,
} as any)

const AppTermsAgreementRoute = AppTermsAgreementImport.update({
  id: '/terms-agreement',
  path: '/terms-agreement',
  getParentRoute: () => AppRouteRoute,
} as any)

const CoReservationRouteRoute = CoReservationRouteImport.update({
  id: '/reservation',
  path: '/reservation',
  getParentRoute: () => CoRouteRoute,
} as any)

const CmInternalRouteRoute = CmInternalRouteImport.update({
  id: '/internal',
  path: '/internal',
  getParentRoute: () => CmRouteRoute,
} as any)

const AppReservationRouteRoute = AppReservationRouteImport.update({
  id: '/reservation',
  path: '/reservation',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCycleRouteRoute = AppCycleRouteImport.update({
  id: '/cycle',
  path: '/cycle',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCoachRouteRoute = AppCoachRouteImport.update({
  id: '/coach',
  path: '/coach',
  getParentRoute: () => AppRouteRoute,
} as any)

const HrCycleListIndexRoute = HrCycleListIndexImport.update({
  id: '/cycle-list/',
  path: '/cycle-list/',
  getParentRoute: () => HrRouteRoute,
} as any)

const HrCaseRegistrationIndexRoute = HrCaseRegistrationIndexImport.update({
  id: '/case-registration/',
  path: '/case-registration/',
  getParentRoute: () => HrRouteRoute,
} as any)

const CoReservationIndexRoute = CoReservationIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CoReservationRouteRoute,
} as any)

const CoCycleListIndexRoute = CoCycleListIndexImport.update({
  id: '/cycle-list/',
  path: '/cycle-list/',
  getParentRoute: () => CoRouteRoute,
} as any)

const CmSendReportsIndexRoute = CmSendReportsIndexImport.update({
  id: '/send-reports/',
  path: '/send-reports/',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmCycleListIndexRoute = CmCycleListIndexImport.update({
  id: '/cycle-list/',
  path: '/cycle-list/',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmCoachMatchingIndexRoute = CmCoachMatchingIndexImport.update({
  id: '/coach-matching/',
  path: '/coach-matching/',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmCaseListIndexRoute = CmCaseListIndexImport.update({
  id: '/case-list/',
  path: '/case-list/',
  getParentRoute: () => CmRouteRoute,
} as any)

const AuthAdminAccessIndexRoute = AuthAdminAccessIndexImport.update({
  id: '/auth/admin-access/',
  path: '/auth/admin-access/',
  getParentRoute: () => rootRoute,
} as any)

const AppReservationIndexRoute = AppReservationIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReservationRouteRoute,
} as any)

const AppCycleIndexRoute = AppCycleIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCycleRouteRoute,
} as any)

const AppCoachIndexRoute = AppCoachIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCoachRouteRoute,
} as any)

const PublicCoachingReportsCoachingReportIdRoute =
  PublicCoachingReportsCoachingReportIdImport.update({
    id: '/coaching-reports/$coachingReportId',
    path: '/coaching-reports/$coachingReportId',
    getParentRoute: () => PublicRouteRoute,
  } as any)

const PublicCoachingPlansCoachingPlanIdRoute =
  PublicCoachingPlansCoachingPlanIdImport.update({
    id: '/coaching-plans/$coachingPlanId',
    path: '/coaching-plans/$coachingPlanId',
    getParentRoute: () => PublicRouteRoute,
  } as any)

const PublicCoachingNotesCoachingNoteIdRoute =
  PublicCoachingNotesCoachingNoteIdImport.update({
    id: '/coaching-notes/$coachingNoteId',
    path: '/coaching-notes/$coachingNoteId',
    getParentRoute: () => PublicRouteRoute,
  } as any)

const HrCycleListCompanyIdRoute = HrCycleListCompanyIdImport.update({
  id: '/cycle-list/$companyId',
  path: '/cycle-list/$companyId',
  getParentRoute: () => HrRouteRoute,
} as any)

const DocsPeerFeedbackReportsPeerFeedbackReportIdRoute =
  DocsPeerFeedbackReportsPeerFeedbackReportIdImport.update({
    id: '/peer-feedback-reports/$peerFeedbackReportId',
    path: '/peer-feedback-reports/$peerFeedbackReportId',
    getParentRoute: () => DocsRouteRoute,
  } as any)

const DocsOnboardingSurveyIdRoute = DocsOnboardingSurveyIdImport.update({
  id: '/onboarding-survey/$id',
  path: '/onboarding-survey/$id',
  getParentRoute: () => DocsRouteRoute,
} as any)

const DocsOccupationalHealthReportIdRoute =
  DocsOccupationalHealthReportIdImport.update({
    id: '/occupational-health-report/$id',
    path: '/occupational-health-report/$id',
    getParentRoute: () => DocsRouteRoute,
  } as any)

const DocsMissionSummaryIdRoute = DocsMissionSummaryIdImport.update({
  id: '/mission-summary/$id',
  path: '/mission-summary/$id',
  getParentRoute: () => DocsRouteRoute,
} as any)

const DocsLeadershipSummaryIdRoute = DocsLeadershipSummaryIdImport.update({
  id: '/leadership-summary/$id',
  path: '/leadership-summary/$id',
  getParentRoute: () => DocsRouteRoute,
} as any)

const DocsCoachingReportsCoachingReportIdRoute =
  DocsCoachingReportsCoachingReportIdImport.update({
    id: '/coaching-reports/$coachingReportId',
    path: '/coaching-reports/$coachingReportId',
    getParentRoute: () => DocsRouteRoute,
  } as any)

const DocsCoachingPlansCoachingPlanIdRoute =
  DocsCoachingPlansCoachingPlanIdImport.update({
    id: '/coaching-plans/$coachingPlanId',
    path: '/coaching-plans/$coachingPlanId',
    getParentRoute: () => DocsRouteRoute,
  } as any)

const DocsCoachingNotesCoachingNoteIdRoute =
  DocsCoachingNotesCoachingNoteIdImport.update({
    id: '/coaching-notes/$coachingNoteId',
    path: '/coaching-notes/$coachingNoteId',
    getParentRoute: () => DocsRouteRoute,
  } as any)

const CoCycleListCompanyIdRoute = CoCycleListCompanyIdImport.update({
  id: '/cycle-list/$companyId',
  path: '/cycle-list/$companyId',
  getParentRoute: () => CoRouteRoute,
} as any)

const CoCycleDetailCycleIdRoute = CoCycleDetailCycleIdImport.update({
  id: '/cycle-detail/$cycleId',
  path: '/cycle-detail/$cycleId',
  getParentRoute: () => CoRouteRoute,
} as any)

const CoCaseDetailCaseIdRoute = CoCaseDetailCaseIdImport.update({
  id: '/case-detail/$caseId',
  path: '/case-detail/$caseId',
  getParentRoute: () => CoRouteRoute,
} as any)

const CmSendReportsCompanyIdRoute = CmSendReportsCompanyIdImport.update({
  id: '/send-reports/$companyId',
  path: '/send-reports/$companyId',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmInternalCompanyStatusRoute = CmInternalCompanyStatusImport.update({
  id: '/company-status',
  path: '/company-status',
  getParentRoute: () => CmInternalRouteRoute,
} as any)

const CmInternalAdminAccessRoute = CmInternalAdminAccessImport.update({
  id: '/admin-access',
  path: '/admin-access',
  getParentRoute: () => CmInternalRouteRoute,
} as any)

const CmCycleListCompanyIdRoute = CmCycleListCompanyIdImport.update({
  id: '/cycle-list/$companyId',
  path: '/cycle-list/$companyId',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmCycleDetailCycleIdRoute = CmCycleDetailCycleIdImport.update({
  id: '/cycle-detail/$cycleId',
  path: '/cycle-detail/$cycleId',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmCoachMatchingCompanyIdRoute = CmCoachMatchingCompanyIdImport.update({
  id: '/coach-matching/$companyId',
  path: '/coach-matching/$companyId',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmCaseListCompanyIdRoute = CmCaseListCompanyIdImport.update({
  id: '/case-list/$companyId',
  path: '/case-list/$companyId',
  getParentRoute: () => CmRouteRoute,
} as any)

const CmCaseDetailCaseIdRoute = CmCaseDetailCaseIdImport.update({
  id: '/case-detail/$caseId',
  path: '/case-detail/$caseId',
  getParentRoute: () => CmRouteRoute,
} as any)

const AuthHrSetupInitialPasswordRoute = AuthHrSetupInitialPasswordImport.update(
  {
    id: '/auth/hr/setup-initial-password',
    path: '/auth/hr/setup-initial-password',
    getParentRoute: () => rootRoute,
  } as any,
)

const AuthAdminAccessEndedRoute = AuthAdminAccessEndedImport.update({
  id: '/auth/admin-access/ended',
  path: '/auth/admin-access/ended',
  getParentRoute: () => rootRoute,
} as any)

const AppReservationFirstRoute = AppReservationFirstImport.update({
  id: '/first',
  path: '/first',
  getParentRoute: () => AppReservationRouteRoute,
} as any)

const AppReservationDetailsRoute = AppReservationDetailsImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => AppReservationRouteRoute,
} as any)

const AppCoachProfileRoute = AppCoachProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppCoachRouteRoute,
} as any)

const CmInternalNotificationTemplatesRouteRoute =
  CmInternalNotificationTemplatesRouteImport.update({
    id: '/notification-templates',
    path: '/notification-templates',
    getParentRoute: () => CmInternalRouteRoute,
  } as any)

const CmInternalNotificationTemplatesIndexRoute =
  CmInternalNotificationTemplatesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CmInternalNotificationTemplatesRouteRoute,
  } as any)

const CmInternalInsightsIndexRoute = CmInternalInsightsIndexImport.update({
  id: '/insights/',
  path: '/insights/',
  getParentRoute: () => CmInternalRouteRoute,
} as any)

const CmInternalEmailIndexRoute = CmInternalEmailIndexImport.update({
  id: '/email/',
  path: '/email/',
  getParentRoute: () => CmInternalRouteRoute,
} as any)

const CmInternalConsoleDataIndexRoute = CmInternalConsoleDataIndexImport.update(
  {
    id: '/console-data/',
    path: '/console-data/',
    getParentRoute: () => CmInternalRouteRoute,
  } as any,
)

const CmInternalCoachListIndexRoute = CmInternalCoachListIndexImport.update({
  id: '/coach-list/',
  path: '/coach-list/',
  getParentRoute: () => CmInternalRouteRoute,
} as any)

const CmInternalAlignmentCallsIndexRoute =
  CmInternalAlignmentCallsIndexImport.update({
    id: '/alignment-calls/',
    path: '/alignment-calls/',
    getParentRoute: () => CmInternalRouteRoute,
  } as any)

const CmInternalNotificationTemplatesCompanyIdRoute =
  CmInternalNotificationTemplatesCompanyIdImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => CmInternalNotificationTemplatesRouteRoute,
  } as any)

const CmInternalConsoleDataCompanyIdRoute =
  CmInternalConsoleDataCompanyIdImport.update({
    id: '/console-data/$companyId',
    path: '/console-data/$companyId',
    getParentRoute: () => CmInternalRouteRoute,
  } as any)

const CmInternalAlignmentCallsCompanyIdRoute =
  CmInternalAlignmentCallsCompanyIdImport.update({
    id: '/alignment-calls/$companyId',
    path: '/alignment-calls/$companyId',
    getParentRoute: () => CmInternalRouteRoute,
  } as any)

const AppCycleCycleIdSurveyIndexRoute = AppCycleCycleIdSurveyIndexImport.update(
  {
    id: '/$cycleId/survey/',
    path: '/$cycleId/survey/',
    getParentRoute: () => AppCycleRouteRoute,
  } as any,
)

const CmInternalInsightsCompaniesCompanyIdRoute =
  CmInternalInsightsCompaniesCompanyIdImport.update({
    id: '/insights/companies/$companyId',
    path: '/insights/companies/$companyId',
    getParentRoute: () => CmInternalRouteRoute,
  } as any)

const CmInternalInsightsCoachesCoachIdRoute =
  CmInternalInsightsCoachesCoachIdImport.update({
    id: '/insights/coaches/$coachId',
    path: '/insights/coaches/$coachId',
    getParentRoute: () => CmInternalRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingIndexRoute =
  AppCycleCycleIdSurveyOnboardingIndexImport.update({
    id: '/$cycleId/survey/onboarding/',
    path: '/$cycleId/survey/onboarding/',
    getParentRoute: () => AppCycleRouteRoute,
  } as any)

const AppCycleCycleIdSurveyFortySurveyTypeIndexRoute =
  AppCycleCycleIdSurveyFortySurveyTypeIndexImport.update({
    id: '/$cycleId/survey/$fortySurveyType/',
    path: '/$cycleId/survey/$fortySurveyType/',
    getParentRoute: () => AppCycleRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute =
  AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport.update({
    id: '/$cycleId/survey/onboarding/$surveyId',
    path: '/$cycleId/survey/onboarding/$surveyId',
    getParentRoute: () => AppCycleRouteRoute,
  } as any)

const AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRoute =
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteImport.update({
    id: '/$cycleId/survey/$fortySurveyType/$surveyId',
    path: '/$cycleId/survey/$fortySurveyType/$surveyId',
    getParentRoute: () => AppCycleRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute =
  AppCycleCycleIdSurveyOnboardingSurveyIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute =
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute =
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultImport.update({
    id: '/pages/result',
    path: '/pages/result',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route =
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Import.update({
    id: '/pages/part2',
    path: '/pages/part2',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route =
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Import.update({
    id: '/pages/part1',
    path: '/pages/part1',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute =
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroImport.update({
    id: '/pages/intro',
    path: '/pages/intro',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute =
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingImport.update({
    id: '/pages/coach-matching',
    path: '/pages/coach-matching',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute =
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroImport.update({
    id: '/pages/coach-intro',
    path: '/pages/coach-intro',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route =
  AppCycleCycleIdSurveyOnboardingSurveyIdPages3Import.update({
    id: '/pages/3',
    path: '/pages/3',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route =
  AppCycleCycleIdSurveyOnboardingSurveyIdPages2Import.update({
    id: '/pages/2',
    path: '/pages/2',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route =
  AppCycleCycleIdSurveyOnboardingSurveyIdPages1Import.update({
    id: '/pages/1',
    path: '/pages/1',
    getParentRoute: () => AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute,
  } as any)

const AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute =
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageImport.update({
    id: '/pages/$page',
    path: '/pages/$page',
    getParentRoute: () =>
      AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/cm': {
      id: '/cm'
      path: '/cm'
      fullPath: '/cm'
      preLoaderRoute: typeof CmRouteImport
      parentRoute: typeof rootRoute
    }
    '/co': {
      id: '/co'
      path: '/co'
      fullPath: '/co'
      preLoaderRoute: typeof CoRouteImport
      parentRoute: typeof rootRoute
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRoute
    }
    '/hr': {
      id: '/hr'
      path: '/hr'
      fullPath: '/hr'
      preLoaderRoute: typeof HrRouteImport
      parentRoute: typeof rootRoute
    }
    '/public': {
      id: '/public'
      path: '/public'
      fullPath: '/public'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRoute
    }
    '/app/coach': {
      id: '/app/coach'
      path: '/coach'
      fullPath: '/app/coach'
      preLoaderRoute: typeof AppCoachRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/cycle': {
      id: '/app/cycle'
      path: '/cycle'
      fullPath: '/app/cycle'
      preLoaderRoute: typeof AppCycleRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/reservation': {
      id: '/app/reservation'
      path: '/reservation'
      fullPath: '/app/reservation'
      preLoaderRoute: typeof AppReservationRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/cm/internal': {
      id: '/cm/internal'
      path: '/internal'
      fullPath: '/cm/internal'
      preLoaderRoute: typeof CmInternalRouteImport
      parentRoute: typeof CmRouteImport
    }
    '/co/reservation': {
      id: '/co/reservation'
      path: '/reservation'
      fullPath: '/co/reservation'
      preLoaderRoute: typeof CoReservationRouteImport
      parentRoute: typeof CoRouteImport
    }
    '/app/terms-agreement': {
      id: '/app/terms-agreement'
      path: '/terms-agreement'
      fullPath: '/app/terms-agreement'
      preLoaderRoute: typeof AppTermsAgreementImport
      parentRoute: typeof AppRouteImport
    }
    '/auth/account-locked': {
      id: '/auth/account-locked'
      path: '/auth/account-locked'
      fullPath: '/auth/account-locked'
      preLoaderRoute: typeof AuthAccountLockedImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutImport
      parentRoute: typeof rootRoute
    }
    '/auth/page-selector': {
      id: '/auth/page-selector'
      path: '/auth/page-selector'
      fullPath: '/auth/page-selector'
      preLoaderRoute: typeof AuthPageSelectorImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password-from-link': {
      id: '/auth/reset-password-from-link'
      path: '/auth/reset-password-from-link'
      fullPath: '/auth/reset-password-from-link'
      preLoaderRoute: typeof AuthResetPasswordFromLinkImport
      parentRoute: typeof rootRoute
    }
    '/auth/send-password-reset-email': {
      id: '/auth/send-password-reset-email'
      path: '/auth/send-password-reset-email'
      fullPath: '/auth/send-password-reset-email'
      preLoaderRoute: typeof AuthSendPasswordResetEmailImport
      parentRoute: typeof rootRoute
    }
    '/auth/setup-initial-password': {
      id: '/auth/setup-initial-password'
      path: '/auth/setup-initial-password'
      fullPath: '/auth/setup-initial-password'
      preLoaderRoute: typeof AuthSetupInitialPasswordImport
      parentRoute: typeof rootRoute
    }
    '/cm/$': {
      id: '/cm/$'
      path: '/$'
      fullPath: '/cm/$'
      preLoaderRoute: typeof CmSplatImport
      parentRoute: typeof CmRouteImport
    }
    '/co/insights': {
      id: '/co/insights'
      path: '/insights'
      fullPath: '/co/insights'
      preLoaderRoute: typeof CoInsightsImport
      parentRoute: typeof CoRouteImport
    }
    '/docs/session-feedback': {
      id: '/docs/session-feedback'
      path: '/session-feedback'
      fullPath: '/docs/session-feedback'
      preLoaderRoute: typeof DocsSessionFeedbackImport
      parentRoute: typeof DocsRouteImport
    }
    '/public/leader-context-document': {
      id: '/public/leader-context-document'
      path: '/leader-context-document'
      fullPath: '/public/leader-context-document'
      preLoaderRoute: typeof PublicLeaderContextDocumentImport
      parentRoute: typeof PublicRouteImport
    }
    '/public/session-feedback': {
      id: '/public/session-feedback'
      path: '/session-feedback'
      fullPath: '/public/session-feedback'
      preLoaderRoute: typeof PublicSessionFeedbackImport
      parentRoute: typeof PublicRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/cm/': {
      id: '/cm/'
      path: '/'
      fullPath: '/cm/'
      preLoaderRoute: typeof CmIndexImport
      parentRoute: typeof CmRouteImport
    }
    '/co/': {
      id: '/co/'
      path: '/'
      fullPath: '/co/'
      preLoaderRoute: typeof CoIndexImport
      parentRoute: typeof CoRouteImport
    }
    '/hr/': {
      id: '/hr/'
      path: '/'
      fullPath: '/hr/'
      preLoaderRoute: typeof HrIndexImport
      parentRoute: typeof HrRouteImport
    }
    '/cm/internal/notification-templates': {
      id: '/cm/internal/notification-templates'
      path: '/notification-templates'
      fullPath: '/cm/internal/notification-templates'
      preLoaderRoute: typeof CmInternalNotificationTemplatesRouteImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/app/coach/profile': {
      id: '/app/coach/profile'
      path: '/profile'
      fullPath: '/app/coach/profile'
      preLoaderRoute: typeof AppCoachProfileImport
      parentRoute: typeof AppCoachRouteImport
    }
    '/app/reservation/details': {
      id: '/app/reservation/details'
      path: '/details'
      fullPath: '/app/reservation/details'
      preLoaderRoute: typeof AppReservationDetailsImport
      parentRoute: typeof AppReservationRouteImport
    }
    '/app/reservation/first': {
      id: '/app/reservation/first'
      path: '/first'
      fullPath: '/app/reservation/first'
      preLoaderRoute: typeof AppReservationFirstImport
      parentRoute: typeof AppReservationRouteImport
    }
    '/auth/admin-access/ended': {
      id: '/auth/admin-access/ended'
      path: '/auth/admin-access/ended'
      fullPath: '/auth/admin-access/ended'
      preLoaderRoute: typeof AuthAdminAccessEndedImport
      parentRoute: typeof rootRoute
    }
    '/auth/hr/setup-initial-password': {
      id: '/auth/hr/setup-initial-password'
      path: '/auth/hr/setup-initial-password'
      fullPath: '/auth/hr/setup-initial-password'
      preLoaderRoute: typeof AuthHrSetupInitialPasswordImport
      parentRoute: typeof rootRoute
    }
    '/cm/case-detail/$caseId': {
      id: '/cm/case-detail/$caseId'
      path: '/case-detail/$caseId'
      fullPath: '/cm/case-detail/$caseId'
      preLoaderRoute: typeof CmCaseDetailCaseIdImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/case-list/$companyId': {
      id: '/cm/case-list/$companyId'
      path: '/case-list/$companyId'
      fullPath: '/cm/case-list/$companyId'
      preLoaderRoute: typeof CmCaseListCompanyIdImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/coach-matching/$companyId': {
      id: '/cm/coach-matching/$companyId'
      path: '/coach-matching/$companyId'
      fullPath: '/cm/coach-matching/$companyId'
      preLoaderRoute: typeof CmCoachMatchingCompanyIdImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/cycle-detail/$cycleId': {
      id: '/cm/cycle-detail/$cycleId'
      path: '/cycle-detail/$cycleId'
      fullPath: '/cm/cycle-detail/$cycleId'
      preLoaderRoute: typeof CmCycleDetailCycleIdImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/cycle-list/$companyId': {
      id: '/cm/cycle-list/$companyId'
      path: '/cycle-list/$companyId'
      fullPath: '/cm/cycle-list/$companyId'
      preLoaderRoute: typeof CmCycleListCompanyIdImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/internal/admin-access': {
      id: '/cm/internal/admin-access'
      path: '/admin-access'
      fullPath: '/cm/internal/admin-access'
      preLoaderRoute: typeof CmInternalAdminAccessImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/company-status': {
      id: '/cm/internal/company-status'
      path: '/company-status'
      fullPath: '/cm/internal/company-status'
      preLoaderRoute: typeof CmInternalCompanyStatusImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/send-reports/$companyId': {
      id: '/cm/send-reports/$companyId'
      path: '/send-reports/$companyId'
      fullPath: '/cm/send-reports/$companyId'
      preLoaderRoute: typeof CmSendReportsCompanyIdImport
      parentRoute: typeof CmRouteImport
    }
    '/co/case-detail/$caseId': {
      id: '/co/case-detail/$caseId'
      path: '/case-detail/$caseId'
      fullPath: '/co/case-detail/$caseId'
      preLoaderRoute: typeof CoCaseDetailCaseIdImport
      parentRoute: typeof CoRouteImport
    }
    '/co/cycle-detail/$cycleId': {
      id: '/co/cycle-detail/$cycleId'
      path: '/cycle-detail/$cycleId'
      fullPath: '/co/cycle-detail/$cycleId'
      preLoaderRoute: typeof CoCycleDetailCycleIdImport
      parentRoute: typeof CoRouteImport
    }
    '/co/cycle-list/$companyId': {
      id: '/co/cycle-list/$companyId'
      path: '/cycle-list/$companyId'
      fullPath: '/co/cycle-list/$companyId'
      preLoaderRoute: typeof CoCycleListCompanyIdImport
      parentRoute: typeof CoRouteImport
    }
    '/docs/coaching-notes/$coachingNoteId': {
      id: '/docs/coaching-notes/$coachingNoteId'
      path: '/coaching-notes/$coachingNoteId'
      fullPath: '/docs/coaching-notes/$coachingNoteId'
      preLoaderRoute: typeof DocsCoachingNotesCoachingNoteIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/docs/coaching-plans/$coachingPlanId': {
      id: '/docs/coaching-plans/$coachingPlanId'
      path: '/coaching-plans/$coachingPlanId'
      fullPath: '/docs/coaching-plans/$coachingPlanId'
      preLoaderRoute: typeof DocsCoachingPlansCoachingPlanIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/docs/coaching-reports/$coachingReportId': {
      id: '/docs/coaching-reports/$coachingReportId'
      path: '/coaching-reports/$coachingReportId'
      fullPath: '/docs/coaching-reports/$coachingReportId'
      preLoaderRoute: typeof DocsCoachingReportsCoachingReportIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/docs/leadership-summary/$id': {
      id: '/docs/leadership-summary/$id'
      path: '/leadership-summary/$id'
      fullPath: '/docs/leadership-summary/$id'
      preLoaderRoute: typeof DocsLeadershipSummaryIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/docs/mission-summary/$id': {
      id: '/docs/mission-summary/$id'
      path: '/mission-summary/$id'
      fullPath: '/docs/mission-summary/$id'
      preLoaderRoute: typeof DocsMissionSummaryIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/docs/occupational-health-report/$id': {
      id: '/docs/occupational-health-report/$id'
      path: '/occupational-health-report/$id'
      fullPath: '/docs/occupational-health-report/$id'
      preLoaderRoute: typeof DocsOccupationalHealthReportIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/docs/onboarding-survey/$id': {
      id: '/docs/onboarding-survey/$id'
      path: '/onboarding-survey/$id'
      fullPath: '/docs/onboarding-survey/$id'
      preLoaderRoute: typeof DocsOnboardingSurveyIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/docs/peer-feedback-reports/$peerFeedbackReportId': {
      id: '/docs/peer-feedback-reports/$peerFeedbackReportId'
      path: '/peer-feedback-reports/$peerFeedbackReportId'
      fullPath: '/docs/peer-feedback-reports/$peerFeedbackReportId'
      preLoaderRoute: typeof DocsPeerFeedbackReportsPeerFeedbackReportIdImport
      parentRoute: typeof DocsRouteImport
    }
    '/hr/cycle-list/$companyId': {
      id: '/hr/cycle-list/$companyId'
      path: '/cycle-list/$companyId'
      fullPath: '/hr/cycle-list/$companyId'
      preLoaderRoute: typeof HrCycleListCompanyIdImport
      parentRoute: typeof HrRouteImport
    }
    '/public/coaching-notes/$coachingNoteId': {
      id: '/public/coaching-notes/$coachingNoteId'
      path: '/coaching-notes/$coachingNoteId'
      fullPath: '/public/coaching-notes/$coachingNoteId'
      preLoaderRoute: typeof PublicCoachingNotesCoachingNoteIdImport
      parentRoute: typeof PublicRouteImport
    }
    '/public/coaching-plans/$coachingPlanId': {
      id: '/public/coaching-plans/$coachingPlanId'
      path: '/coaching-plans/$coachingPlanId'
      fullPath: '/public/coaching-plans/$coachingPlanId'
      preLoaderRoute: typeof PublicCoachingPlansCoachingPlanIdImport
      parentRoute: typeof PublicRouteImport
    }
    '/public/coaching-reports/$coachingReportId': {
      id: '/public/coaching-reports/$coachingReportId'
      path: '/coaching-reports/$coachingReportId'
      fullPath: '/public/coaching-reports/$coachingReportId'
      preLoaderRoute: typeof PublicCoachingReportsCoachingReportIdImport
      parentRoute: typeof PublicRouteImport
    }
    '/app/coach/': {
      id: '/app/coach/'
      path: '/'
      fullPath: '/app/coach/'
      preLoaderRoute: typeof AppCoachIndexImport
      parentRoute: typeof AppCoachRouteImport
    }
    '/app/cycle/': {
      id: '/app/cycle/'
      path: '/'
      fullPath: '/app/cycle/'
      preLoaderRoute: typeof AppCycleIndexImport
      parentRoute: typeof AppCycleRouteImport
    }
    '/app/reservation/': {
      id: '/app/reservation/'
      path: '/'
      fullPath: '/app/reservation/'
      preLoaderRoute: typeof AppReservationIndexImport
      parentRoute: typeof AppReservationRouteImport
    }
    '/auth/admin-access/': {
      id: '/auth/admin-access/'
      path: '/auth/admin-access'
      fullPath: '/auth/admin-access'
      preLoaderRoute: typeof AuthAdminAccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/cm/case-list/': {
      id: '/cm/case-list/'
      path: '/case-list'
      fullPath: '/cm/case-list'
      preLoaderRoute: typeof CmCaseListIndexImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/coach-matching/': {
      id: '/cm/coach-matching/'
      path: '/coach-matching'
      fullPath: '/cm/coach-matching'
      preLoaderRoute: typeof CmCoachMatchingIndexImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/cycle-list/': {
      id: '/cm/cycle-list/'
      path: '/cycle-list'
      fullPath: '/cm/cycle-list'
      preLoaderRoute: typeof CmCycleListIndexImport
      parentRoute: typeof CmRouteImport
    }
    '/cm/send-reports/': {
      id: '/cm/send-reports/'
      path: '/send-reports'
      fullPath: '/cm/send-reports'
      preLoaderRoute: typeof CmSendReportsIndexImport
      parentRoute: typeof CmRouteImport
    }
    '/co/cycle-list/': {
      id: '/co/cycle-list/'
      path: '/cycle-list'
      fullPath: '/co/cycle-list'
      preLoaderRoute: typeof CoCycleListIndexImport
      parentRoute: typeof CoRouteImport
    }
    '/co/reservation/': {
      id: '/co/reservation/'
      path: '/'
      fullPath: '/co/reservation/'
      preLoaderRoute: typeof CoReservationIndexImport
      parentRoute: typeof CoReservationRouteImport
    }
    '/hr/case-registration/': {
      id: '/hr/case-registration/'
      path: '/case-registration'
      fullPath: '/hr/case-registration'
      preLoaderRoute: typeof HrCaseRegistrationIndexImport
      parentRoute: typeof HrRouteImport
    }
    '/hr/cycle-list/': {
      id: '/hr/cycle-list/'
      path: '/cycle-list'
      fullPath: '/hr/cycle-list'
      preLoaderRoute: typeof HrCycleListIndexImport
      parentRoute: typeof HrRouteImport
    }
    '/cm/internal/alignment-calls/$companyId': {
      id: '/cm/internal/alignment-calls/$companyId'
      path: '/alignment-calls/$companyId'
      fullPath: '/cm/internal/alignment-calls/$companyId'
      preLoaderRoute: typeof CmInternalAlignmentCallsCompanyIdImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/console-data/$companyId': {
      id: '/cm/internal/console-data/$companyId'
      path: '/console-data/$companyId'
      fullPath: '/cm/internal/console-data/$companyId'
      preLoaderRoute: typeof CmInternalConsoleDataCompanyIdImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/notification-templates/$companyId': {
      id: '/cm/internal/notification-templates/$companyId'
      path: '/$companyId'
      fullPath: '/cm/internal/notification-templates/$companyId'
      preLoaderRoute: typeof CmInternalNotificationTemplatesCompanyIdImport
      parentRoute: typeof CmInternalNotificationTemplatesRouteImport
    }
    '/cm/internal/alignment-calls/': {
      id: '/cm/internal/alignment-calls/'
      path: '/alignment-calls'
      fullPath: '/cm/internal/alignment-calls'
      preLoaderRoute: typeof CmInternalAlignmentCallsIndexImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/coach-list/': {
      id: '/cm/internal/coach-list/'
      path: '/coach-list'
      fullPath: '/cm/internal/coach-list'
      preLoaderRoute: typeof CmInternalCoachListIndexImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/console-data/': {
      id: '/cm/internal/console-data/'
      path: '/console-data'
      fullPath: '/cm/internal/console-data'
      preLoaderRoute: typeof CmInternalConsoleDataIndexImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/email/': {
      id: '/cm/internal/email/'
      path: '/email'
      fullPath: '/cm/internal/email'
      preLoaderRoute: typeof CmInternalEmailIndexImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/insights/': {
      id: '/cm/internal/insights/'
      path: '/insights'
      fullPath: '/cm/internal/insights'
      preLoaderRoute: typeof CmInternalInsightsIndexImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/notification-templates/': {
      id: '/cm/internal/notification-templates/'
      path: '/'
      fullPath: '/cm/internal/notification-templates/'
      preLoaderRoute: typeof CmInternalNotificationTemplatesIndexImport
      parentRoute: typeof CmInternalNotificationTemplatesRouteImport
    }
    '/cm/internal/insights/coaches/$coachId': {
      id: '/cm/internal/insights/coaches/$coachId'
      path: '/insights/coaches/$coachId'
      fullPath: '/cm/internal/insights/coaches/$coachId'
      preLoaderRoute: typeof CmInternalInsightsCoachesCoachIdImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/cm/internal/insights/companies/$companyId': {
      id: '/cm/internal/insights/companies/$companyId'
      path: '/insights/companies/$companyId'
      fullPath: '/cm/internal/insights/companies/$companyId'
      preLoaderRoute: typeof CmInternalInsightsCompaniesCompanyIdImport
      parentRoute: typeof CmInternalRouteImport
    }
    '/app/cycle/$cycleId/survey/': {
      id: '/app/cycle/$cycleId/survey/'
      path: '/$cycleId/survey'
      fullPath: '/app/cycle/$cycleId/survey'
      preLoaderRoute: typeof AppCycleCycleIdSurveyIndexImport
      parentRoute: typeof AppCycleRouteImport
    }
    '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId': {
      id: '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId'
      path: '/$cycleId/survey/$fortySurveyType/$surveyId'
      fullPath: '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId'
      preLoaderRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteImport
      parentRoute: typeof AppCycleRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId'
      path: '/$cycleId/survey/onboarding/$surveyId'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
      parentRoute: typeof AppCycleRouteImport
    }
    '/app/cycle/$cycleId/survey/$fortySurveyType/': {
      id: '/app/cycle/$cycleId/survey/$fortySurveyType/'
      path: '/$cycleId/survey/$fortySurveyType'
      fullPath: '/app/cycle/$cycleId/survey/$fortySurveyType'
      preLoaderRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeIndexImport
      parentRoute: typeof AppCycleRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/': {
      id: '/app/cycle/$cycleId/survey/onboarding/'
      path: '/$cycleId/survey/onboarding'
      fullPath: '/app/cycle/$cycleId/survey/onboarding'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingIndexImport
      parentRoute: typeof AppCycleRouteImport
    }
    '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/': {
      id: '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/'
      path: '/'
      fullPath: '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/'
      preLoaderRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexImport
      parentRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/'
      path: '/'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdIndexImport
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page': {
      id: '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page'
      path: '/pages/$page'
      fullPath: '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page'
      preLoaderRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageImport
      parentRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1'
      path: '/pages/1'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages1Import
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2'
      path: '/pages/2'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages2Import
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3'
      path: '/pages/3'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages3Import
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro'
      path: '/pages/coach-intro'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroImport
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching'
      path: '/pages/coach-matching'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingImport
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro'
      path: '/pages/intro'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroImport
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1'
      path: '/pages/part1'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Import
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2'
      path: '/pages/part2'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Import
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
    '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result': {
      id: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result'
      path: '/pages/result'
      fullPath: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result'
      preLoaderRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultImport
      parentRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteImport
    }
  }
}

// Create and export the route tree

interface AppCoachRouteRouteChildren {
  AppCoachProfileRoute: typeof AppCoachProfileRoute
  AppCoachIndexRoute: typeof AppCoachIndexRoute
}

const AppCoachRouteRouteChildren: AppCoachRouteRouteChildren = {
  AppCoachProfileRoute: AppCoachProfileRoute,
  AppCoachIndexRoute: AppCoachIndexRoute,
}

const AppCoachRouteRouteWithChildren = AppCoachRouteRoute._addFileChildren(
  AppCoachRouteRouteChildren,
)

interface AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteChildren {
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute
}

const AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteChildren: AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteChildren =
  {
    AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute:
      AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute,
    AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute:
      AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute,
  }

const AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteWithChildren =
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRoute._addFileChildren(
    AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteChildren,
  )

interface AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteChildren {
  AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute
  AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route
  AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route
  AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route
  AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute
}

const AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteChildren: AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteChildren =
  {
    AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute:
      AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute,
    AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route:
      AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route,
    AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route:
      AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route,
    AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route:
      AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route,
    AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute:
      AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute,
    AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute:
      AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute,
    AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute:
      AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute,
    AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route:
      AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route,
    AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route:
      AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route,
    AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute:
      AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute,
  }

const AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteWithChildren =
  AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute._addFileChildren(
    AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteChildren,
  )

interface AppCycleRouteRouteChildren {
  AppCycleIndexRoute: typeof AppCycleIndexRoute
  AppCycleCycleIdSurveyIndexRoute: typeof AppCycleCycleIdSurveyIndexRoute
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteWithChildren
  AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute: typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteWithChildren
  AppCycleCycleIdSurveyFortySurveyTypeIndexRoute: typeof AppCycleCycleIdSurveyFortySurveyTypeIndexRoute
  AppCycleCycleIdSurveyOnboardingIndexRoute: typeof AppCycleCycleIdSurveyOnboardingIndexRoute
}

const AppCycleRouteRouteChildren: AppCycleRouteRouteChildren = {
  AppCycleIndexRoute: AppCycleIndexRoute,
  AppCycleCycleIdSurveyIndexRoute: AppCycleCycleIdSurveyIndexRoute,
  AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRoute:
    AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteWithChildren,
  AppCycleCycleIdSurveyOnboardingSurveyIdRouteRoute:
    AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteWithChildren,
  AppCycleCycleIdSurveyFortySurveyTypeIndexRoute:
    AppCycleCycleIdSurveyFortySurveyTypeIndexRoute,
  AppCycleCycleIdSurveyOnboardingIndexRoute:
    AppCycleCycleIdSurveyOnboardingIndexRoute,
}

const AppCycleRouteRouteWithChildren = AppCycleRouteRoute._addFileChildren(
  AppCycleRouteRouteChildren,
)

interface AppReservationRouteRouteChildren {
  AppReservationDetailsRoute: typeof AppReservationDetailsRoute
  AppReservationFirstRoute: typeof AppReservationFirstRoute
  AppReservationIndexRoute: typeof AppReservationIndexRoute
}

const AppReservationRouteRouteChildren: AppReservationRouteRouteChildren = {
  AppReservationDetailsRoute: AppReservationDetailsRoute,
  AppReservationFirstRoute: AppReservationFirstRoute,
  AppReservationIndexRoute: AppReservationIndexRoute,
}

const AppReservationRouteRouteWithChildren =
  AppReservationRouteRoute._addFileChildren(AppReservationRouteRouteChildren)

interface AppRouteRouteChildren {
  AppCoachRouteRoute: typeof AppCoachRouteRouteWithChildren
  AppCycleRouteRoute: typeof AppCycleRouteRouteWithChildren
  AppReservationRouteRoute: typeof AppReservationRouteRouteWithChildren
  AppTermsAgreementRoute: typeof AppTermsAgreementRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppCoachRouteRoute: AppCoachRouteRouteWithChildren,
  AppCycleRouteRoute: AppCycleRouteRouteWithChildren,
  AppReservationRouteRoute: AppReservationRouteRouteWithChildren,
  AppTermsAgreementRoute: AppTermsAgreementRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface CmInternalNotificationTemplatesRouteRouteChildren {
  CmInternalNotificationTemplatesCompanyIdRoute: typeof CmInternalNotificationTemplatesCompanyIdRoute
  CmInternalNotificationTemplatesIndexRoute: typeof CmInternalNotificationTemplatesIndexRoute
}

const CmInternalNotificationTemplatesRouteRouteChildren: CmInternalNotificationTemplatesRouteRouteChildren =
  {
    CmInternalNotificationTemplatesCompanyIdRoute:
      CmInternalNotificationTemplatesCompanyIdRoute,
    CmInternalNotificationTemplatesIndexRoute:
      CmInternalNotificationTemplatesIndexRoute,
  }

const CmInternalNotificationTemplatesRouteRouteWithChildren =
  CmInternalNotificationTemplatesRouteRoute._addFileChildren(
    CmInternalNotificationTemplatesRouteRouteChildren,
  )

interface CmInternalRouteRouteChildren {
  CmInternalNotificationTemplatesRouteRoute: typeof CmInternalNotificationTemplatesRouteRouteWithChildren
  CmInternalAdminAccessRoute: typeof CmInternalAdminAccessRoute
  CmInternalCompanyStatusRoute: typeof CmInternalCompanyStatusRoute
  CmInternalAlignmentCallsCompanyIdRoute: typeof CmInternalAlignmentCallsCompanyIdRoute
  CmInternalConsoleDataCompanyIdRoute: typeof CmInternalConsoleDataCompanyIdRoute
  CmInternalAlignmentCallsIndexRoute: typeof CmInternalAlignmentCallsIndexRoute
  CmInternalCoachListIndexRoute: typeof CmInternalCoachListIndexRoute
  CmInternalConsoleDataIndexRoute: typeof CmInternalConsoleDataIndexRoute
  CmInternalEmailIndexRoute: typeof CmInternalEmailIndexRoute
  CmInternalInsightsIndexRoute: typeof CmInternalInsightsIndexRoute
  CmInternalInsightsCoachesCoachIdRoute: typeof CmInternalInsightsCoachesCoachIdRoute
  CmInternalInsightsCompaniesCompanyIdRoute: typeof CmInternalInsightsCompaniesCompanyIdRoute
}

const CmInternalRouteRouteChildren: CmInternalRouteRouteChildren = {
  CmInternalNotificationTemplatesRouteRoute:
    CmInternalNotificationTemplatesRouteRouteWithChildren,
  CmInternalAdminAccessRoute: CmInternalAdminAccessRoute,
  CmInternalCompanyStatusRoute: CmInternalCompanyStatusRoute,
  CmInternalAlignmentCallsCompanyIdRoute:
    CmInternalAlignmentCallsCompanyIdRoute,
  CmInternalConsoleDataCompanyIdRoute: CmInternalConsoleDataCompanyIdRoute,
  CmInternalAlignmentCallsIndexRoute: CmInternalAlignmentCallsIndexRoute,
  CmInternalCoachListIndexRoute: CmInternalCoachListIndexRoute,
  CmInternalConsoleDataIndexRoute: CmInternalConsoleDataIndexRoute,
  CmInternalEmailIndexRoute: CmInternalEmailIndexRoute,
  CmInternalInsightsIndexRoute: CmInternalInsightsIndexRoute,
  CmInternalInsightsCoachesCoachIdRoute: CmInternalInsightsCoachesCoachIdRoute,
  CmInternalInsightsCompaniesCompanyIdRoute:
    CmInternalInsightsCompaniesCompanyIdRoute,
}

const CmInternalRouteRouteWithChildren = CmInternalRouteRoute._addFileChildren(
  CmInternalRouteRouteChildren,
)

interface CmRouteRouteChildren {
  CmInternalRouteRoute: typeof CmInternalRouteRouteWithChildren
  CmSplatRoute: typeof CmSplatRoute
  CmIndexRoute: typeof CmIndexRoute
  CmCaseDetailCaseIdRoute: typeof CmCaseDetailCaseIdRoute
  CmCaseListCompanyIdRoute: typeof CmCaseListCompanyIdRoute
  CmCoachMatchingCompanyIdRoute: typeof CmCoachMatchingCompanyIdRoute
  CmCycleDetailCycleIdRoute: typeof CmCycleDetailCycleIdRoute
  CmCycleListCompanyIdRoute: typeof CmCycleListCompanyIdRoute
  CmSendReportsCompanyIdRoute: typeof CmSendReportsCompanyIdRoute
  CmCaseListIndexRoute: typeof CmCaseListIndexRoute
  CmCoachMatchingIndexRoute: typeof CmCoachMatchingIndexRoute
  CmCycleListIndexRoute: typeof CmCycleListIndexRoute
  CmSendReportsIndexRoute: typeof CmSendReportsIndexRoute
}

const CmRouteRouteChildren: CmRouteRouteChildren = {
  CmInternalRouteRoute: CmInternalRouteRouteWithChildren,
  CmSplatRoute: CmSplatRoute,
  CmIndexRoute: CmIndexRoute,
  CmCaseDetailCaseIdRoute: CmCaseDetailCaseIdRoute,
  CmCaseListCompanyIdRoute: CmCaseListCompanyIdRoute,
  CmCoachMatchingCompanyIdRoute: CmCoachMatchingCompanyIdRoute,
  CmCycleDetailCycleIdRoute: CmCycleDetailCycleIdRoute,
  CmCycleListCompanyIdRoute: CmCycleListCompanyIdRoute,
  CmSendReportsCompanyIdRoute: CmSendReportsCompanyIdRoute,
  CmCaseListIndexRoute: CmCaseListIndexRoute,
  CmCoachMatchingIndexRoute: CmCoachMatchingIndexRoute,
  CmCycleListIndexRoute: CmCycleListIndexRoute,
  CmSendReportsIndexRoute: CmSendReportsIndexRoute,
}

const CmRouteRouteWithChildren =
  CmRouteRoute._addFileChildren(CmRouteRouteChildren)

interface CoReservationRouteRouteChildren {
  CoReservationIndexRoute: typeof CoReservationIndexRoute
}

const CoReservationRouteRouteChildren: CoReservationRouteRouteChildren = {
  CoReservationIndexRoute: CoReservationIndexRoute,
}

const CoReservationRouteRouteWithChildren =
  CoReservationRouteRoute._addFileChildren(CoReservationRouteRouteChildren)

interface CoRouteRouteChildren {
  CoReservationRouteRoute: typeof CoReservationRouteRouteWithChildren
  CoInsightsRoute: typeof CoInsightsRoute
  CoIndexRoute: typeof CoIndexRoute
  CoCaseDetailCaseIdRoute: typeof CoCaseDetailCaseIdRoute
  CoCycleDetailCycleIdRoute: typeof CoCycleDetailCycleIdRoute
  CoCycleListCompanyIdRoute: typeof CoCycleListCompanyIdRoute
  CoCycleListIndexRoute: typeof CoCycleListIndexRoute
}

const CoRouteRouteChildren: CoRouteRouteChildren = {
  CoReservationRouteRoute: CoReservationRouteRouteWithChildren,
  CoInsightsRoute: CoInsightsRoute,
  CoIndexRoute: CoIndexRoute,
  CoCaseDetailCaseIdRoute: CoCaseDetailCaseIdRoute,
  CoCycleDetailCycleIdRoute: CoCycleDetailCycleIdRoute,
  CoCycleListCompanyIdRoute: CoCycleListCompanyIdRoute,
  CoCycleListIndexRoute: CoCycleListIndexRoute,
}

const CoRouteRouteWithChildren =
  CoRouteRoute._addFileChildren(CoRouteRouteChildren)

interface DocsRouteRouteChildren {
  DocsSessionFeedbackRoute: typeof DocsSessionFeedbackRoute
  DocsCoachingNotesCoachingNoteIdRoute: typeof DocsCoachingNotesCoachingNoteIdRoute
  DocsCoachingPlansCoachingPlanIdRoute: typeof DocsCoachingPlansCoachingPlanIdRoute
  DocsCoachingReportsCoachingReportIdRoute: typeof DocsCoachingReportsCoachingReportIdRoute
  DocsLeadershipSummaryIdRoute: typeof DocsLeadershipSummaryIdRoute
  DocsMissionSummaryIdRoute: typeof DocsMissionSummaryIdRoute
  DocsOccupationalHealthReportIdRoute: typeof DocsOccupationalHealthReportIdRoute
  DocsOnboardingSurveyIdRoute: typeof DocsOnboardingSurveyIdRoute
  DocsPeerFeedbackReportsPeerFeedbackReportIdRoute: typeof DocsPeerFeedbackReportsPeerFeedbackReportIdRoute
}

const DocsRouteRouteChildren: DocsRouteRouteChildren = {
  DocsSessionFeedbackRoute: DocsSessionFeedbackRoute,
  DocsCoachingNotesCoachingNoteIdRoute: DocsCoachingNotesCoachingNoteIdRoute,
  DocsCoachingPlansCoachingPlanIdRoute: DocsCoachingPlansCoachingPlanIdRoute,
  DocsCoachingReportsCoachingReportIdRoute:
    DocsCoachingReportsCoachingReportIdRoute,
  DocsLeadershipSummaryIdRoute: DocsLeadershipSummaryIdRoute,
  DocsMissionSummaryIdRoute: DocsMissionSummaryIdRoute,
  DocsOccupationalHealthReportIdRoute: DocsOccupationalHealthReportIdRoute,
  DocsOnboardingSurveyIdRoute: DocsOnboardingSurveyIdRoute,
  DocsPeerFeedbackReportsPeerFeedbackReportIdRoute:
    DocsPeerFeedbackReportsPeerFeedbackReportIdRoute,
}

const DocsRouteRouteWithChildren = DocsRouteRoute._addFileChildren(
  DocsRouteRouteChildren,
)

interface HrRouteRouteChildren {
  HrIndexRoute: typeof HrIndexRoute
  HrCycleListCompanyIdRoute: typeof HrCycleListCompanyIdRoute
  HrCaseRegistrationIndexRoute: typeof HrCaseRegistrationIndexRoute
  HrCycleListIndexRoute: typeof HrCycleListIndexRoute
}

const HrRouteRouteChildren: HrRouteRouteChildren = {
  HrIndexRoute: HrIndexRoute,
  HrCycleListCompanyIdRoute: HrCycleListCompanyIdRoute,
  HrCaseRegistrationIndexRoute: HrCaseRegistrationIndexRoute,
  HrCycleListIndexRoute: HrCycleListIndexRoute,
}

const HrRouteRouteWithChildren =
  HrRouteRoute._addFileChildren(HrRouteRouteChildren)

interface PublicRouteRouteChildren {
  PublicLeaderContextDocumentRoute: typeof PublicLeaderContextDocumentRoute
  PublicSessionFeedbackRoute: typeof PublicSessionFeedbackRoute
  PublicCoachingNotesCoachingNoteIdRoute: typeof PublicCoachingNotesCoachingNoteIdRoute
  PublicCoachingPlansCoachingPlanIdRoute: typeof PublicCoachingPlansCoachingPlanIdRoute
  PublicCoachingReportsCoachingReportIdRoute: typeof PublicCoachingReportsCoachingReportIdRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicLeaderContextDocumentRoute: PublicLeaderContextDocumentRoute,
  PublicSessionFeedbackRoute: PublicSessionFeedbackRoute,
  PublicCoachingNotesCoachingNoteIdRoute:
    PublicCoachingNotesCoachingNoteIdRoute,
  PublicCoachingPlansCoachingPlanIdRoute:
    PublicCoachingPlansCoachingPlanIdRoute,
  PublicCoachingReportsCoachingReportIdRoute:
    PublicCoachingReportsCoachingReportIdRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/cm': typeof CmRouteRouteWithChildren
  '/co': typeof CoRouteRouteWithChildren
  '/docs': typeof DocsRouteRouteWithChildren
  '/hr': typeof HrRouteRouteWithChildren
  '/public': typeof PublicRouteRouteWithChildren
  '/app/coach': typeof AppCoachRouteRouteWithChildren
  '/app/cycle': typeof AppCycleRouteRouteWithChildren
  '/app/reservation': typeof AppReservationRouteRouteWithChildren
  '/cm/internal': typeof CmInternalRouteRouteWithChildren
  '/co/reservation': typeof CoReservationRouteRouteWithChildren
  '/app/terms-agreement': typeof AppTermsAgreementRoute
  '/auth/account-locked': typeof AuthAccountLockedRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/page-selector': typeof AuthPageSelectorRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/reset-password-from-link': typeof AuthResetPasswordFromLinkRoute
  '/auth/send-password-reset-email': typeof AuthSendPasswordResetEmailRoute
  '/auth/setup-initial-password': typeof AuthSetupInitialPasswordRoute
  '/cm/$': typeof CmSplatRoute
  '/co/insights': typeof CoInsightsRoute
  '/docs/session-feedback': typeof DocsSessionFeedbackRoute
  '/public/leader-context-document': typeof PublicLeaderContextDocumentRoute
  '/public/session-feedback': typeof PublicSessionFeedbackRoute
  '/app/': typeof AppIndexRoute
  '/cm/': typeof CmIndexRoute
  '/co/': typeof CoIndexRoute
  '/hr/': typeof HrIndexRoute
  '/cm/internal/notification-templates': typeof CmInternalNotificationTemplatesRouteRouteWithChildren
  '/app/coach/profile': typeof AppCoachProfileRoute
  '/app/reservation/details': typeof AppReservationDetailsRoute
  '/app/reservation/first': typeof AppReservationFirstRoute
  '/auth/admin-access/ended': typeof AuthAdminAccessEndedRoute
  '/auth/hr/setup-initial-password': typeof AuthHrSetupInitialPasswordRoute
  '/cm/case-detail/$caseId': typeof CmCaseDetailCaseIdRoute
  '/cm/case-list/$companyId': typeof CmCaseListCompanyIdRoute
  '/cm/coach-matching/$companyId': typeof CmCoachMatchingCompanyIdRoute
  '/cm/cycle-detail/$cycleId': typeof CmCycleDetailCycleIdRoute
  '/cm/cycle-list/$companyId': typeof CmCycleListCompanyIdRoute
  '/cm/internal/admin-access': typeof CmInternalAdminAccessRoute
  '/cm/internal/company-status': typeof CmInternalCompanyStatusRoute
  '/cm/send-reports/$companyId': typeof CmSendReportsCompanyIdRoute
  '/co/case-detail/$caseId': typeof CoCaseDetailCaseIdRoute
  '/co/cycle-detail/$cycleId': typeof CoCycleDetailCycleIdRoute
  '/co/cycle-list/$companyId': typeof CoCycleListCompanyIdRoute
  '/docs/coaching-notes/$coachingNoteId': typeof DocsCoachingNotesCoachingNoteIdRoute
  '/docs/coaching-plans/$coachingPlanId': typeof DocsCoachingPlansCoachingPlanIdRoute
  '/docs/coaching-reports/$coachingReportId': typeof DocsCoachingReportsCoachingReportIdRoute
  '/docs/leadership-summary/$id': typeof DocsLeadershipSummaryIdRoute
  '/docs/mission-summary/$id': typeof DocsMissionSummaryIdRoute
  '/docs/occupational-health-report/$id': typeof DocsOccupationalHealthReportIdRoute
  '/docs/onboarding-survey/$id': typeof DocsOnboardingSurveyIdRoute
  '/docs/peer-feedback-reports/$peerFeedbackReportId': typeof DocsPeerFeedbackReportsPeerFeedbackReportIdRoute
  '/hr/cycle-list/$companyId': typeof HrCycleListCompanyIdRoute
  '/public/coaching-notes/$coachingNoteId': typeof PublicCoachingNotesCoachingNoteIdRoute
  '/public/coaching-plans/$coachingPlanId': typeof PublicCoachingPlansCoachingPlanIdRoute
  '/public/coaching-reports/$coachingReportId': typeof PublicCoachingReportsCoachingReportIdRoute
  '/app/coach/': typeof AppCoachIndexRoute
  '/app/cycle/': typeof AppCycleIndexRoute
  '/app/reservation/': typeof AppReservationIndexRoute
  '/auth/admin-access': typeof AuthAdminAccessIndexRoute
  '/cm/case-list': typeof CmCaseListIndexRoute
  '/cm/coach-matching': typeof CmCoachMatchingIndexRoute
  '/cm/cycle-list': typeof CmCycleListIndexRoute
  '/cm/send-reports': typeof CmSendReportsIndexRoute
  '/co/cycle-list': typeof CoCycleListIndexRoute
  '/co/reservation/': typeof CoReservationIndexRoute
  '/hr/case-registration': typeof HrCaseRegistrationIndexRoute
  '/hr/cycle-list': typeof HrCycleListIndexRoute
  '/cm/internal/alignment-calls/$companyId': typeof CmInternalAlignmentCallsCompanyIdRoute
  '/cm/internal/console-data/$companyId': typeof CmInternalConsoleDataCompanyIdRoute
  '/cm/internal/notification-templates/$companyId': typeof CmInternalNotificationTemplatesCompanyIdRoute
  '/cm/internal/alignment-calls': typeof CmInternalAlignmentCallsIndexRoute
  '/cm/internal/coach-list': typeof CmInternalCoachListIndexRoute
  '/cm/internal/console-data': typeof CmInternalConsoleDataIndexRoute
  '/cm/internal/email': typeof CmInternalEmailIndexRoute
  '/cm/internal/insights': typeof CmInternalInsightsIndexRoute
  '/cm/internal/notification-templates/': typeof CmInternalNotificationTemplatesIndexRoute
  '/cm/internal/insights/coaches/$coachId': typeof CmInternalInsightsCoachesCoachIdRoute
  '/cm/internal/insights/companies/$companyId': typeof CmInternalInsightsCompaniesCompanyIdRoute
  '/app/cycle/$cycleId/survey': typeof AppCycleCycleIdSurveyIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteWithChildren
  '/app/cycle/$cycleId/survey/onboarding/$surveyId': typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteWithChildren
  '/app/cycle/$cycleId/survey/$fortySurveyType': typeof AppCycleCycleIdSurveyFortySurveyTypeIndexRoute
  '/app/cycle/$cycleId/survey/onboarding': typeof AppCycleCycleIdSurveyOnboardingIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/': typeof AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/docs': typeof DocsRouteRouteWithChildren
  '/public': typeof PublicRouteRouteWithChildren
  '/cm/internal': typeof CmInternalRouteRouteWithChildren
  '/app/terms-agreement': typeof AppTermsAgreementRoute
  '/auth/account-locked': typeof AuthAccountLockedRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/page-selector': typeof AuthPageSelectorRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/reset-password-from-link': typeof AuthResetPasswordFromLinkRoute
  '/auth/send-password-reset-email': typeof AuthSendPasswordResetEmailRoute
  '/auth/setup-initial-password': typeof AuthSetupInitialPasswordRoute
  '/cm/$': typeof CmSplatRoute
  '/co/insights': typeof CoInsightsRoute
  '/docs/session-feedback': typeof DocsSessionFeedbackRoute
  '/public/leader-context-document': typeof PublicLeaderContextDocumentRoute
  '/public/session-feedback': typeof PublicSessionFeedbackRoute
  '/app': typeof AppIndexRoute
  '/cm': typeof CmIndexRoute
  '/co': typeof CoIndexRoute
  '/hr': typeof HrIndexRoute
  '/app/coach/profile': typeof AppCoachProfileRoute
  '/app/reservation/details': typeof AppReservationDetailsRoute
  '/app/reservation/first': typeof AppReservationFirstRoute
  '/auth/admin-access/ended': typeof AuthAdminAccessEndedRoute
  '/auth/hr/setup-initial-password': typeof AuthHrSetupInitialPasswordRoute
  '/cm/case-detail/$caseId': typeof CmCaseDetailCaseIdRoute
  '/cm/case-list/$companyId': typeof CmCaseListCompanyIdRoute
  '/cm/coach-matching/$companyId': typeof CmCoachMatchingCompanyIdRoute
  '/cm/cycle-detail/$cycleId': typeof CmCycleDetailCycleIdRoute
  '/cm/cycle-list/$companyId': typeof CmCycleListCompanyIdRoute
  '/cm/internal/admin-access': typeof CmInternalAdminAccessRoute
  '/cm/internal/company-status': typeof CmInternalCompanyStatusRoute
  '/cm/send-reports/$companyId': typeof CmSendReportsCompanyIdRoute
  '/co/case-detail/$caseId': typeof CoCaseDetailCaseIdRoute
  '/co/cycle-detail/$cycleId': typeof CoCycleDetailCycleIdRoute
  '/co/cycle-list/$companyId': typeof CoCycleListCompanyIdRoute
  '/docs/coaching-notes/$coachingNoteId': typeof DocsCoachingNotesCoachingNoteIdRoute
  '/docs/coaching-plans/$coachingPlanId': typeof DocsCoachingPlansCoachingPlanIdRoute
  '/docs/coaching-reports/$coachingReportId': typeof DocsCoachingReportsCoachingReportIdRoute
  '/docs/leadership-summary/$id': typeof DocsLeadershipSummaryIdRoute
  '/docs/mission-summary/$id': typeof DocsMissionSummaryIdRoute
  '/docs/occupational-health-report/$id': typeof DocsOccupationalHealthReportIdRoute
  '/docs/onboarding-survey/$id': typeof DocsOnboardingSurveyIdRoute
  '/docs/peer-feedback-reports/$peerFeedbackReportId': typeof DocsPeerFeedbackReportsPeerFeedbackReportIdRoute
  '/hr/cycle-list/$companyId': typeof HrCycleListCompanyIdRoute
  '/public/coaching-notes/$coachingNoteId': typeof PublicCoachingNotesCoachingNoteIdRoute
  '/public/coaching-plans/$coachingPlanId': typeof PublicCoachingPlansCoachingPlanIdRoute
  '/public/coaching-reports/$coachingReportId': typeof PublicCoachingReportsCoachingReportIdRoute
  '/app/coach': typeof AppCoachIndexRoute
  '/app/cycle': typeof AppCycleIndexRoute
  '/app/reservation': typeof AppReservationIndexRoute
  '/auth/admin-access': typeof AuthAdminAccessIndexRoute
  '/cm/case-list': typeof CmCaseListIndexRoute
  '/cm/coach-matching': typeof CmCoachMatchingIndexRoute
  '/cm/cycle-list': typeof CmCycleListIndexRoute
  '/cm/send-reports': typeof CmSendReportsIndexRoute
  '/co/cycle-list': typeof CoCycleListIndexRoute
  '/co/reservation': typeof CoReservationIndexRoute
  '/hr/case-registration': typeof HrCaseRegistrationIndexRoute
  '/hr/cycle-list': typeof HrCycleListIndexRoute
  '/cm/internal/alignment-calls/$companyId': typeof CmInternalAlignmentCallsCompanyIdRoute
  '/cm/internal/console-data/$companyId': typeof CmInternalConsoleDataCompanyIdRoute
  '/cm/internal/notification-templates/$companyId': typeof CmInternalNotificationTemplatesCompanyIdRoute
  '/cm/internal/alignment-calls': typeof CmInternalAlignmentCallsIndexRoute
  '/cm/internal/coach-list': typeof CmInternalCoachListIndexRoute
  '/cm/internal/console-data': typeof CmInternalConsoleDataIndexRoute
  '/cm/internal/email': typeof CmInternalEmailIndexRoute
  '/cm/internal/insights': typeof CmInternalInsightsIndexRoute
  '/cm/internal/notification-templates': typeof CmInternalNotificationTemplatesIndexRoute
  '/cm/internal/insights/coaches/$coachId': typeof CmInternalInsightsCoachesCoachIdRoute
  '/cm/internal/insights/companies/$companyId': typeof CmInternalInsightsCompaniesCompanyIdRoute
  '/app/cycle/$cycleId/survey': typeof AppCycleCycleIdSurveyIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType': typeof AppCycleCycleIdSurveyFortySurveyTypeIndexRoute
  '/app/cycle/$cycleId/survey/onboarding': typeof AppCycleCycleIdSurveyOnboardingIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId': typeof AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/cm': typeof CmRouteRouteWithChildren
  '/co': typeof CoRouteRouteWithChildren
  '/docs': typeof DocsRouteRouteWithChildren
  '/hr': typeof HrRouteRouteWithChildren
  '/public': typeof PublicRouteRouteWithChildren
  '/app/coach': typeof AppCoachRouteRouteWithChildren
  '/app/cycle': typeof AppCycleRouteRouteWithChildren
  '/app/reservation': typeof AppReservationRouteRouteWithChildren
  '/cm/internal': typeof CmInternalRouteRouteWithChildren
  '/co/reservation': typeof CoReservationRouteRouteWithChildren
  '/app/terms-agreement': typeof AppTermsAgreementRoute
  '/auth/account-locked': typeof AuthAccountLockedRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/page-selector': typeof AuthPageSelectorRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/reset-password-from-link': typeof AuthResetPasswordFromLinkRoute
  '/auth/send-password-reset-email': typeof AuthSendPasswordResetEmailRoute
  '/auth/setup-initial-password': typeof AuthSetupInitialPasswordRoute
  '/cm/$': typeof CmSplatRoute
  '/co/insights': typeof CoInsightsRoute
  '/docs/session-feedback': typeof DocsSessionFeedbackRoute
  '/public/leader-context-document': typeof PublicLeaderContextDocumentRoute
  '/public/session-feedback': typeof PublicSessionFeedbackRoute
  '/app/': typeof AppIndexRoute
  '/cm/': typeof CmIndexRoute
  '/co/': typeof CoIndexRoute
  '/hr/': typeof HrIndexRoute
  '/cm/internal/notification-templates': typeof CmInternalNotificationTemplatesRouteRouteWithChildren
  '/app/coach/profile': typeof AppCoachProfileRoute
  '/app/reservation/details': typeof AppReservationDetailsRoute
  '/app/reservation/first': typeof AppReservationFirstRoute
  '/auth/admin-access/ended': typeof AuthAdminAccessEndedRoute
  '/auth/hr/setup-initial-password': typeof AuthHrSetupInitialPasswordRoute
  '/cm/case-detail/$caseId': typeof CmCaseDetailCaseIdRoute
  '/cm/case-list/$companyId': typeof CmCaseListCompanyIdRoute
  '/cm/coach-matching/$companyId': typeof CmCoachMatchingCompanyIdRoute
  '/cm/cycle-detail/$cycleId': typeof CmCycleDetailCycleIdRoute
  '/cm/cycle-list/$companyId': typeof CmCycleListCompanyIdRoute
  '/cm/internal/admin-access': typeof CmInternalAdminAccessRoute
  '/cm/internal/company-status': typeof CmInternalCompanyStatusRoute
  '/cm/send-reports/$companyId': typeof CmSendReportsCompanyIdRoute
  '/co/case-detail/$caseId': typeof CoCaseDetailCaseIdRoute
  '/co/cycle-detail/$cycleId': typeof CoCycleDetailCycleIdRoute
  '/co/cycle-list/$companyId': typeof CoCycleListCompanyIdRoute
  '/docs/coaching-notes/$coachingNoteId': typeof DocsCoachingNotesCoachingNoteIdRoute
  '/docs/coaching-plans/$coachingPlanId': typeof DocsCoachingPlansCoachingPlanIdRoute
  '/docs/coaching-reports/$coachingReportId': typeof DocsCoachingReportsCoachingReportIdRoute
  '/docs/leadership-summary/$id': typeof DocsLeadershipSummaryIdRoute
  '/docs/mission-summary/$id': typeof DocsMissionSummaryIdRoute
  '/docs/occupational-health-report/$id': typeof DocsOccupationalHealthReportIdRoute
  '/docs/onboarding-survey/$id': typeof DocsOnboardingSurveyIdRoute
  '/docs/peer-feedback-reports/$peerFeedbackReportId': typeof DocsPeerFeedbackReportsPeerFeedbackReportIdRoute
  '/hr/cycle-list/$companyId': typeof HrCycleListCompanyIdRoute
  '/public/coaching-notes/$coachingNoteId': typeof PublicCoachingNotesCoachingNoteIdRoute
  '/public/coaching-plans/$coachingPlanId': typeof PublicCoachingPlansCoachingPlanIdRoute
  '/public/coaching-reports/$coachingReportId': typeof PublicCoachingReportsCoachingReportIdRoute
  '/app/coach/': typeof AppCoachIndexRoute
  '/app/cycle/': typeof AppCycleIndexRoute
  '/app/reservation/': typeof AppReservationIndexRoute
  '/auth/admin-access/': typeof AuthAdminAccessIndexRoute
  '/cm/case-list/': typeof CmCaseListIndexRoute
  '/cm/coach-matching/': typeof CmCoachMatchingIndexRoute
  '/cm/cycle-list/': typeof CmCycleListIndexRoute
  '/cm/send-reports/': typeof CmSendReportsIndexRoute
  '/co/cycle-list/': typeof CoCycleListIndexRoute
  '/co/reservation/': typeof CoReservationIndexRoute
  '/hr/case-registration/': typeof HrCaseRegistrationIndexRoute
  '/hr/cycle-list/': typeof HrCycleListIndexRoute
  '/cm/internal/alignment-calls/$companyId': typeof CmInternalAlignmentCallsCompanyIdRoute
  '/cm/internal/console-data/$companyId': typeof CmInternalConsoleDataCompanyIdRoute
  '/cm/internal/notification-templates/$companyId': typeof CmInternalNotificationTemplatesCompanyIdRoute
  '/cm/internal/alignment-calls/': typeof CmInternalAlignmentCallsIndexRoute
  '/cm/internal/coach-list/': typeof CmInternalCoachListIndexRoute
  '/cm/internal/console-data/': typeof CmInternalConsoleDataIndexRoute
  '/cm/internal/email/': typeof CmInternalEmailIndexRoute
  '/cm/internal/insights/': typeof CmInternalInsightsIndexRoute
  '/cm/internal/notification-templates/': typeof CmInternalNotificationTemplatesIndexRoute
  '/cm/internal/insights/coaches/$coachId': typeof CmInternalInsightsCoachesCoachIdRoute
  '/cm/internal/insights/companies/$companyId': typeof CmInternalInsightsCompaniesCompanyIdRoute
  '/app/cycle/$cycleId/survey/': typeof AppCycleCycleIdSurveyIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdRouteRouteWithChildren
  '/app/cycle/$cycleId/survey/onboarding/$surveyId': typeof AppCycleCycleIdSurveyOnboardingSurveyIdRouteRouteWithChildren
  '/app/cycle/$cycleId/survey/$fortySurveyType/': typeof AppCycleCycleIdSurveyFortySurveyTypeIndexRoute
  '/app/cycle/$cycleId/survey/onboarding/': typeof AppCycleCycleIdSurveyOnboardingIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdIndexRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/': typeof AppCycleCycleIdSurveyOnboardingSurveyIdIndexRoute
  '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page': typeof AppCycleCycleIdSurveyFortySurveyTypeSurveyIdPagesPageRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages1Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages2Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPages3Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachIntroRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesCoachMatchingRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesIntroRoute
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart1Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesPart2Route
  '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result': typeof AppCycleCycleIdSurveyOnboardingSurveyIdPagesResultRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/cm'
    | '/co'
    | '/docs'
    | '/hr'
    | '/public'
    | '/app/coach'
    | '/app/cycle'
    | '/app/reservation'
    | '/cm/internal'
    | '/co/reservation'
    | '/app/terms-agreement'
    | '/auth/account-locked'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/page-selector'
    | '/auth/reset-password'
    | '/auth/reset-password-from-link'
    | '/auth/send-password-reset-email'
    | '/auth/setup-initial-password'
    | '/cm/$'
    | '/co/insights'
    | '/docs/session-feedback'
    | '/public/leader-context-document'
    | '/public/session-feedback'
    | '/app/'
    | '/cm/'
    | '/co/'
    | '/hr/'
    | '/cm/internal/notification-templates'
    | '/app/coach/profile'
    | '/app/reservation/details'
    | '/app/reservation/first'
    | '/auth/admin-access/ended'
    | '/auth/hr/setup-initial-password'
    | '/cm/case-detail/$caseId'
    | '/cm/case-list/$companyId'
    | '/cm/coach-matching/$companyId'
    | '/cm/cycle-detail/$cycleId'
    | '/cm/cycle-list/$companyId'
    | '/cm/internal/admin-access'
    | '/cm/internal/company-status'
    | '/cm/send-reports/$companyId'
    | '/co/case-detail/$caseId'
    | '/co/cycle-detail/$cycleId'
    | '/co/cycle-list/$companyId'
    | '/docs/coaching-notes/$coachingNoteId'
    | '/docs/coaching-plans/$coachingPlanId'
    | '/docs/coaching-reports/$coachingReportId'
    | '/docs/leadership-summary/$id'
    | '/docs/mission-summary/$id'
    | '/docs/occupational-health-report/$id'
    | '/docs/onboarding-survey/$id'
    | '/docs/peer-feedback-reports/$peerFeedbackReportId'
    | '/hr/cycle-list/$companyId'
    | '/public/coaching-notes/$coachingNoteId'
    | '/public/coaching-plans/$coachingPlanId'
    | '/public/coaching-reports/$coachingReportId'
    | '/app/coach/'
    | '/app/cycle/'
    | '/app/reservation/'
    | '/auth/admin-access'
    | '/cm/case-list'
    | '/cm/coach-matching'
    | '/cm/cycle-list'
    | '/cm/send-reports'
    | '/co/cycle-list'
    | '/co/reservation/'
    | '/hr/case-registration'
    | '/hr/cycle-list'
    | '/cm/internal/alignment-calls/$companyId'
    | '/cm/internal/console-data/$companyId'
    | '/cm/internal/notification-templates/$companyId'
    | '/cm/internal/alignment-calls'
    | '/cm/internal/coach-list'
    | '/cm/internal/console-data'
    | '/cm/internal/email'
    | '/cm/internal/insights'
    | '/cm/internal/notification-templates/'
    | '/cm/internal/insights/coaches/$coachId'
    | '/cm/internal/insights/companies/$companyId'
    | '/app/cycle/$cycleId/survey'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId'
    | '/app/cycle/$cycleId/survey/$fortySurveyType'
    | '/app/cycle/$cycleId/survey/onboarding'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/docs'
    | '/public'
    | '/cm/internal'
    | '/app/terms-agreement'
    | '/auth/account-locked'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/page-selector'
    | '/auth/reset-password'
    | '/auth/reset-password-from-link'
    | '/auth/send-password-reset-email'
    | '/auth/setup-initial-password'
    | '/cm/$'
    | '/co/insights'
    | '/docs/session-feedback'
    | '/public/leader-context-document'
    | '/public/session-feedback'
    | '/app'
    | '/cm'
    | '/co'
    | '/hr'
    | '/app/coach/profile'
    | '/app/reservation/details'
    | '/app/reservation/first'
    | '/auth/admin-access/ended'
    | '/auth/hr/setup-initial-password'
    | '/cm/case-detail/$caseId'
    | '/cm/case-list/$companyId'
    | '/cm/coach-matching/$companyId'
    | '/cm/cycle-detail/$cycleId'
    | '/cm/cycle-list/$companyId'
    | '/cm/internal/admin-access'
    | '/cm/internal/company-status'
    | '/cm/send-reports/$companyId'
    | '/co/case-detail/$caseId'
    | '/co/cycle-detail/$cycleId'
    | '/co/cycle-list/$companyId'
    | '/docs/coaching-notes/$coachingNoteId'
    | '/docs/coaching-plans/$coachingPlanId'
    | '/docs/coaching-reports/$coachingReportId'
    | '/docs/leadership-summary/$id'
    | '/docs/mission-summary/$id'
    | '/docs/occupational-health-report/$id'
    | '/docs/onboarding-survey/$id'
    | '/docs/peer-feedback-reports/$peerFeedbackReportId'
    | '/hr/cycle-list/$companyId'
    | '/public/coaching-notes/$coachingNoteId'
    | '/public/coaching-plans/$coachingPlanId'
    | '/public/coaching-reports/$coachingReportId'
    | '/app/coach'
    | '/app/cycle'
    | '/app/reservation'
    | '/auth/admin-access'
    | '/cm/case-list'
    | '/cm/coach-matching'
    | '/cm/cycle-list'
    | '/cm/send-reports'
    | '/co/cycle-list'
    | '/co/reservation'
    | '/hr/case-registration'
    | '/hr/cycle-list'
    | '/cm/internal/alignment-calls/$companyId'
    | '/cm/internal/console-data/$companyId'
    | '/cm/internal/notification-templates/$companyId'
    | '/cm/internal/alignment-calls'
    | '/cm/internal/coach-list'
    | '/cm/internal/console-data'
    | '/cm/internal/email'
    | '/cm/internal/insights'
    | '/cm/internal/notification-templates'
    | '/cm/internal/insights/coaches/$coachId'
    | '/cm/internal/insights/companies/$companyId'
    | '/app/cycle/$cycleId/survey'
    | '/app/cycle/$cycleId/survey/$fortySurveyType'
    | '/app/cycle/$cycleId/survey/onboarding'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/cm'
    | '/co'
    | '/docs'
    | '/hr'
    | '/public'
    | '/app/coach'
    | '/app/cycle'
    | '/app/reservation'
    | '/cm/internal'
    | '/co/reservation'
    | '/app/terms-agreement'
    | '/auth/account-locked'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/page-selector'
    | '/auth/reset-password'
    | '/auth/reset-password-from-link'
    | '/auth/send-password-reset-email'
    | '/auth/setup-initial-password'
    | '/cm/$'
    | '/co/insights'
    | '/docs/session-feedback'
    | '/public/leader-context-document'
    | '/public/session-feedback'
    | '/app/'
    | '/cm/'
    | '/co/'
    | '/hr/'
    | '/cm/internal/notification-templates'
    | '/app/coach/profile'
    | '/app/reservation/details'
    | '/app/reservation/first'
    | '/auth/admin-access/ended'
    | '/auth/hr/setup-initial-password'
    | '/cm/case-detail/$caseId'
    | '/cm/case-list/$companyId'
    | '/cm/coach-matching/$companyId'
    | '/cm/cycle-detail/$cycleId'
    | '/cm/cycle-list/$companyId'
    | '/cm/internal/admin-access'
    | '/cm/internal/company-status'
    | '/cm/send-reports/$companyId'
    | '/co/case-detail/$caseId'
    | '/co/cycle-detail/$cycleId'
    | '/co/cycle-list/$companyId'
    | '/docs/coaching-notes/$coachingNoteId'
    | '/docs/coaching-plans/$coachingPlanId'
    | '/docs/coaching-reports/$coachingReportId'
    | '/docs/leadership-summary/$id'
    | '/docs/mission-summary/$id'
    | '/docs/occupational-health-report/$id'
    | '/docs/onboarding-survey/$id'
    | '/docs/peer-feedback-reports/$peerFeedbackReportId'
    | '/hr/cycle-list/$companyId'
    | '/public/coaching-notes/$coachingNoteId'
    | '/public/coaching-plans/$coachingPlanId'
    | '/public/coaching-reports/$coachingReportId'
    | '/app/coach/'
    | '/app/cycle/'
    | '/app/reservation/'
    | '/auth/admin-access/'
    | '/cm/case-list/'
    | '/cm/coach-matching/'
    | '/cm/cycle-list/'
    | '/cm/send-reports/'
    | '/co/cycle-list/'
    | '/co/reservation/'
    | '/hr/case-registration/'
    | '/hr/cycle-list/'
    | '/cm/internal/alignment-calls/$companyId'
    | '/cm/internal/console-data/$companyId'
    | '/cm/internal/notification-templates/$companyId'
    | '/cm/internal/alignment-calls/'
    | '/cm/internal/coach-list/'
    | '/cm/internal/console-data/'
    | '/cm/internal/email/'
    | '/cm/internal/insights/'
    | '/cm/internal/notification-templates/'
    | '/cm/internal/insights/coaches/$coachId'
    | '/cm/internal/insights/companies/$companyId'
    | '/app/cycle/$cycleId/survey/'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/'
    | '/app/cycle/$cycleId/survey/onboarding/'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/'
    | '/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2'
    | '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  CmRouteRoute: typeof CmRouteRouteWithChildren
  CoRouteRoute: typeof CoRouteRouteWithChildren
  DocsRouteRoute: typeof DocsRouteRouteWithChildren
  HrRouteRoute: typeof HrRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  AuthAccountLockedRoute: typeof AuthAccountLockedRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthPageSelectorRoute: typeof AuthPageSelectorRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthResetPasswordFromLinkRoute: typeof AuthResetPasswordFromLinkRoute
  AuthSendPasswordResetEmailRoute: typeof AuthSendPasswordResetEmailRoute
  AuthSetupInitialPasswordRoute: typeof AuthSetupInitialPasswordRoute
  AuthAdminAccessEndedRoute: typeof AuthAdminAccessEndedRoute
  AuthHrSetupInitialPasswordRoute: typeof AuthHrSetupInitialPasswordRoute
  AuthAdminAccessIndexRoute: typeof AuthAdminAccessIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  CmRouteRoute: CmRouteRouteWithChildren,
  CoRouteRoute: CoRouteRouteWithChildren,
  DocsRouteRoute: DocsRouteRouteWithChildren,
  HrRouteRoute: HrRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  AuthAccountLockedRoute: AuthAccountLockedRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthPageSelectorRoute: AuthPageSelectorRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthResetPasswordFromLinkRoute: AuthResetPasswordFromLinkRoute,
  AuthSendPasswordResetEmailRoute: AuthSendPasswordResetEmailRoute,
  AuthSetupInitialPasswordRoute: AuthSetupInitialPasswordRoute,
  AuthAdminAccessEndedRoute: AuthAdminAccessEndedRoute,
  AuthHrSetupInitialPasswordRoute: AuthHrSetupInitialPasswordRoute,
  AuthAdminAccessIndexRoute: AuthAdminAccessIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/app",
        "/cm",
        "/co",
        "/docs",
        "/hr",
        "/public",
        "/auth/account-locked",
        "/auth/login",
        "/auth/logout",
        "/auth/page-selector",
        "/auth/reset-password",
        "/auth/reset-password-from-link",
        "/auth/send-password-reset-email",
        "/auth/setup-initial-password",
        "/auth/admin-access/ended",
        "/auth/hr/setup-initial-password",
        "/auth/admin-access/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/app": {
      "filePath": "app/route.tsx",
      "children": [
        "/app/coach",
        "/app/cycle",
        "/app/reservation",
        "/app/terms-agreement",
        "/app/"
      ]
    },
    "/cm": {
      "filePath": "cm/route.tsx",
      "children": [
        "/cm/internal",
        "/cm/$",
        "/cm/",
        "/cm/case-detail/$caseId",
        "/cm/case-list/$companyId",
        "/cm/coach-matching/$companyId",
        "/cm/cycle-detail/$cycleId",
        "/cm/cycle-list/$companyId",
        "/cm/send-reports/$companyId",
        "/cm/case-list/",
        "/cm/coach-matching/",
        "/cm/cycle-list/",
        "/cm/send-reports/"
      ]
    },
    "/co": {
      "filePath": "co/route.tsx",
      "children": [
        "/co/reservation",
        "/co/insights",
        "/co/",
        "/co/case-detail/$caseId",
        "/co/cycle-detail/$cycleId",
        "/co/cycle-list/$companyId",
        "/co/cycle-list/"
      ]
    },
    "/docs": {
      "filePath": "docs/route.tsx",
      "children": [
        "/docs/session-feedback",
        "/docs/coaching-notes/$coachingNoteId",
        "/docs/coaching-plans/$coachingPlanId",
        "/docs/coaching-reports/$coachingReportId",
        "/docs/leadership-summary/$id",
        "/docs/mission-summary/$id",
        "/docs/occupational-health-report/$id",
        "/docs/onboarding-survey/$id",
        "/docs/peer-feedback-reports/$peerFeedbackReportId"
      ]
    },
    "/hr": {
      "filePath": "hr/route.tsx",
      "children": [
        "/hr/",
        "/hr/cycle-list/$companyId",
        "/hr/case-registration/",
        "/hr/cycle-list/"
      ]
    },
    "/public": {
      "filePath": "public/route.tsx",
      "children": [
        "/public/leader-context-document",
        "/public/session-feedback",
        "/public/coaching-notes/$coachingNoteId",
        "/public/coaching-plans/$coachingPlanId",
        "/public/coaching-reports/$coachingReportId"
      ]
    },
    "/app/coach": {
      "filePath": "app/coach/route.tsx",
      "parent": "/app",
      "children": [
        "/app/coach/profile",
        "/app/coach/"
      ]
    },
    "/app/cycle": {
      "filePath": "app/cycle/route.tsx",
      "parent": "/app",
      "children": [
        "/app/cycle/",
        "/app/cycle/$cycleId/survey/",
        "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId",
        "/app/cycle/$cycleId/survey/$fortySurveyType/",
        "/app/cycle/$cycleId/survey/onboarding/"
      ]
    },
    "/app/reservation": {
      "filePath": "app/reservation/route.tsx",
      "parent": "/app",
      "children": [
        "/app/reservation/details",
        "/app/reservation/first",
        "/app/reservation/"
      ]
    },
    "/cm/internal": {
      "filePath": "cm/internal/route.tsx",
      "parent": "/cm",
      "children": [
        "/cm/internal/notification-templates",
        "/cm/internal/admin-access",
        "/cm/internal/company-status",
        "/cm/internal/alignment-calls/$companyId",
        "/cm/internal/console-data/$companyId",
        "/cm/internal/alignment-calls/",
        "/cm/internal/coach-list/",
        "/cm/internal/console-data/",
        "/cm/internal/email/",
        "/cm/internal/insights/",
        "/cm/internal/insights/coaches/$coachId",
        "/cm/internal/insights/companies/$companyId"
      ]
    },
    "/co/reservation": {
      "filePath": "co/reservation/route.tsx",
      "parent": "/co",
      "children": [
        "/co/reservation/"
      ]
    },
    "/app/terms-agreement": {
      "filePath": "app/terms-agreement.tsx",
      "parent": "/app"
    },
    "/auth/account-locked": {
      "filePath": "auth/account-locked.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/logout": {
      "filePath": "auth/logout.tsx"
    },
    "/auth/page-selector": {
      "filePath": "auth/page-selector.tsx"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx"
    },
    "/auth/reset-password-from-link": {
      "filePath": "auth/reset-password-from-link.tsx"
    },
    "/auth/send-password-reset-email": {
      "filePath": "auth/send-password-reset-email.tsx"
    },
    "/auth/setup-initial-password": {
      "filePath": "auth/setup-initial-password.tsx"
    },
    "/cm/$": {
      "filePath": "cm/$.tsx",
      "parent": "/cm"
    },
    "/co/insights": {
      "filePath": "co/insights.tsx",
      "parent": "/co"
    },
    "/docs/session-feedback": {
      "filePath": "docs/session-feedback.tsx",
      "parent": "/docs"
    },
    "/public/leader-context-document": {
      "filePath": "public/leader-context-document.tsx",
      "parent": "/public"
    },
    "/public/session-feedback": {
      "filePath": "public/session-feedback.tsx",
      "parent": "/public"
    },
    "/app/": {
      "filePath": "app/index.tsx",
      "parent": "/app"
    },
    "/cm/": {
      "filePath": "cm/index.tsx",
      "parent": "/cm"
    },
    "/co/": {
      "filePath": "co/index.tsx",
      "parent": "/co"
    },
    "/hr/": {
      "filePath": "hr/index.tsx",
      "parent": "/hr"
    },
    "/cm/internal/notification-templates": {
      "filePath": "cm/internal/notification-templates/route.tsx",
      "parent": "/cm/internal",
      "children": [
        "/cm/internal/notification-templates/$companyId",
        "/cm/internal/notification-templates/"
      ]
    },
    "/app/coach/profile": {
      "filePath": "app/coach/profile.tsx",
      "parent": "/app/coach"
    },
    "/app/reservation/details": {
      "filePath": "app/reservation/details.tsx",
      "parent": "/app/reservation"
    },
    "/app/reservation/first": {
      "filePath": "app/reservation/first.tsx",
      "parent": "/app/reservation"
    },
    "/auth/admin-access/ended": {
      "filePath": "auth/admin-access/ended.tsx"
    },
    "/auth/hr/setup-initial-password": {
      "filePath": "auth/hr/setup-initial-password.tsx"
    },
    "/cm/case-detail/$caseId": {
      "filePath": "cm/case-detail/$caseId.tsx",
      "parent": "/cm"
    },
    "/cm/case-list/$companyId": {
      "filePath": "cm/case-list/$companyId.tsx",
      "parent": "/cm"
    },
    "/cm/coach-matching/$companyId": {
      "filePath": "cm/coach-matching/$companyId.tsx",
      "parent": "/cm"
    },
    "/cm/cycle-detail/$cycleId": {
      "filePath": "cm/cycle-detail/$cycleId.tsx",
      "parent": "/cm"
    },
    "/cm/cycle-list/$companyId": {
      "filePath": "cm/cycle-list/$companyId.tsx",
      "parent": "/cm"
    },
    "/cm/internal/admin-access": {
      "filePath": "cm/internal/admin-access.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/company-status": {
      "filePath": "cm/internal/company-status.tsx",
      "parent": "/cm/internal"
    },
    "/cm/send-reports/$companyId": {
      "filePath": "cm/send-reports/$companyId.tsx",
      "parent": "/cm"
    },
    "/co/case-detail/$caseId": {
      "filePath": "co/case-detail/$caseId.tsx",
      "parent": "/co"
    },
    "/co/cycle-detail/$cycleId": {
      "filePath": "co/cycle-detail/$cycleId.tsx",
      "parent": "/co"
    },
    "/co/cycle-list/$companyId": {
      "filePath": "co/cycle-list/$companyId.tsx",
      "parent": "/co"
    },
    "/docs/coaching-notes/$coachingNoteId": {
      "filePath": "docs/coaching-notes/$coachingNoteId.tsx",
      "parent": "/docs"
    },
    "/docs/coaching-plans/$coachingPlanId": {
      "filePath": "docs/coaching-plans/$coachingPlanId.tsx",
      "parent": "/docs"
    },
    "/docs/coaching-reports/$coachingReportId": {
      "filePath": "docs/coaching-reports/$coachingReportId.tsx",
      "parent": "/docs"
    },
    "/docs/leadership-summary/$id": {
      "filePath": "docs/leadership-summary/$id.tsx",
      "parent": "/docs"
    },
    "/docs/mission-summary/$id": {
      "filePath": "docs/mission-summary/$id.tsx",
      "parent": "/docs"
    },
    "/docs/occupational-health-report/$id": {
      "filePath": "docs/occupational-health-report/$id.tsx",
      "parent": "/docs"
    },
    "/docs/onboarding-survey/$id": {
      "filePath": "docs/onboarding-survey/$id.tsx",
      "parent": "/docs"
    },
    "/docs/peer-feedback-reports/$peerFeedbackReportId": {
      "filePath": "docs/peer-feedback-reports/$peerFeedbackReportId.tsx",
      "parent": "/docs"
    },
    "/hr/cycle-list/$companyId": {
      "filePath": "hr/cycle-list/$companyId.tsx",
      "parent": "/hr"
    },
    "/public/coaching-notes/$coachingNoteId": {
      "filePath": "public/coaching-notes/$coachingNoteId.tsx",
      "parent": "/public"
    },
    "/public/coaching-plans/$coachingPlanId": {
      "filePath": "public/coaching-plans/$coachingPlanId.tsx",
      "parent": "/public"
    },
    "/public/coaching-reports/$coachingReportId": {
      "filePath": "public/coaching-reports/$coachingReportId.tsx",
      "parent": "/public"
    },
    "/app/coach/": {
      "filePath": "app/coach/index.tsx",
      "parent": "/app/coach"
    },
    "/app/cycle/": {
      "filePath": "app/cycle/index.tsx",
      "parent": "/app/cycle"
    },
    "/app/reservation/": {
      "filePath": "app/reservation/index.tsx",
      "parent": "/app/reservation"
    },
    "/auth/admin-access/": {
      "filePath": "auth/admin-access/index.tsx"
    },
    "/cm/case-list/": {
      "filePath": "cm/case-list/index.tsx",
      "parent": "/cm"
    },
    "/cm/coach-matching/": {
      "filePath": "cm/coach-matching/index.tsx",
      "parent": "/cm"
    },
    "/cm/cycle-list/": {
      "filePath": "cm/cycle-list/index.tsx",
      "parent": "/cm"
    },
    "/cm/send-reports/": {
      "filePath": "cm/send-reports/index.tsx",
      "parent": "/cm"
    },
    "/co/cycle-list/": {
      "filePath": "co/cycle-list/index.tsx",
      "parent": "/co"
    },
    "/co/reservation/": {
      "filePath": "co/reservation/index.tsx",
      "parent": "/co/reservation"
    },
    "/hr/case-registration/": {
      "filePath": "hr/case-registration/index.tsx",
      "parent": "/hr"
    },
    "/hr/cycle-list/": {
      "filePath": "hr/cycle-list/index.tsx",
      "parent": "/hr"
    },
    "/cm/internal/alignment-calls/$companyId": {
      "filePath": "cm/internal/alignment-calls/$companyId.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/console-data/$companyId": {
      "filePath": "cm/internal/console-data/$companyId.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/notification-templates/$companyId": {
      "filePath": "cm/internal/notification-templates/$companyId.tsx",
      "parent": "/cm/internal/notification-templates"
    },
    "/cm/internal/alignment-calls/": {
      "filePath": "cm/internal/alignment-calls/index.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/coach-list/": {
      "filePath": "cm/internal/coach-list/index.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/console-data/": {
      "filePath": "cm/internal/console-data/index.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/email/": {
      "filePath": "cm/internal/email/index.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/insights/": {
      "filePath": "cm/internal/insights/index.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/notification-templates/": {
      "filePath": "cm/internal/notification-templates/index.tsx",
      "parent": "/cm/internal/notification-templates"
    },
    "/cm/internal/insights/coaches/$coachId": {
      "filePath": "cm/internal/insights/coaches.$coachId.tsx",
      "parent": "/cm/internal"
    },
    "/cm/internal/insights/companies/$companyId": {
      "filePath": "cm/internal/insights/companies.$companyId.tsx",
      "parent": "/cm/internal"
    },
    "/app/cycle/$cycleId/survey/": {
      "filePath": "app/cycle/$cycleId/survey/index.tsx",
      "parent": "/app/cycle"
    },
    "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId": {
      "filePath": "app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/route.tsx",
      "parent": "/app/cycle",
      "children": [
        "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/",
        "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page"
      ]
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/route.tsx",
      "parent": "/app/cycle",
      "children": [
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2",
        "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result"
      ]
    },
    "/app/cycle/$cycleId/survey/$fortySurveyType/": {
      "filePath": "app/cycle/$cycleId/survey/$fortySurveyType/index.tsx",
      "parent": "/app/cycle"
    },
    "/app/cycle/$cycleId/survey/onboarding/": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/index.tsx",
      "parent": "/app/cycle"
    },
    "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/": {
      "filePath": "app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/index.tsx",
      "parent": "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/index.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page": {
      "filePath": "app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page.tsx",
      "parent": "/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/1.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/2.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/3.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-intro.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/coach-matching.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part1.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/part2.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    },
    "/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result": {
      "filePath": "app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result.tsx",
      "parent": "/app/cycle/$cycleId/survey/onboarding/$surveyId"
    }
  }
}
ROUTE_MANIFEST_END */
